var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127, _defs128, _defs129, _defs130, _defs131, _defs132, _defs133, _defs134, _defs135, _defs136, _defs137, _defs138, _defs139, _defs140, _defs141, _defs142, _defs143, _defs144;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsGear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197 184",
    style: {
      enableBackground: "new 0 0 197 184"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000053523130428506700990000015412785158438799286_);}\n\t.st3{clip-path:url(#SVGID_00000042718212020942467000000002763708830243762822_);}\n\t.st4{clip-path:url(#SVGID_00000096021446302808459920000012844238910268172167_);fill:#55BBB1;}\n\t.st5{clip-path:url(#SVGID_00000147932280074948248610000004729033705637982859_);}\n\t.st6{clip-path:url(#SVGID_00000138541802791454413320000009104873539826005377_);}\n\t.st7{clip-path:url(#SVGID_00000136387248347688320990000011186604437258013876_);fill:#55BBB1;}\n\t.st8{clip-path:url(#SVGID_00000124853682745960722840000004641800703536022917_);}\n\t.st9{clip-path:url(#SVGID_00000059282349763336022670000011023503914069873290_);}\n\t.st10{clip-path:url(#SVGID_00000162341432498559587550000013200601895409412750_);fill:#55BBB1;}\n\t.st11{clip-path:url(#SVGID_00000041982041265070507800000001453372619377303460_);}\n\t.st12{clip-path:url(#SVGID_00000143592250381894632710000002532588661106984633_);}\n\t.st13{clip-path:url(#SVGID_00000173145834305670323120000000198465451841446043_);fill:#55BBB1;}\n\t.st14{clip-path:url(#SVGID_00000152254662644118423980000007395953627298090126_);}\n\t.st15{clip-path:url(#SVGID_00000085956479707394563810000000020460788748673940_);}\n\t.st16{clip-path:url(#SVGID_00000026139429009727684090000003993913139780326060_);fill:#55BBB1;}\n\t.st17{clip-path:url(#SVGID_00000060016973225438555070000013222711268510557361_);}\n\t.st18{clip-path:url(#SVGID_00000026132007230562743080000011028334842532149926_);}\n\t.st19{clip-path:url(#SVGID_00000100346656811896411230000000385070544116160163_);fill:#55BBB1;}\n\t.st20{clip-path:url(#SVGID_00000070829183184838395440000017237501749879449478_);}\n\t.st21{clip-path:url(#SVGID_00000055674576029693806630000015237001065163876785_);}\n\t.st22{clip-path:url(#SVGID_00000163786769945073430060000018082173572603311524_);fill:#55BBB1;}\n\t.st23{clip-path:url(#SVGID_00000057129319775086802810000015930027803843189651_);}\n\t.st24{clip-path:url(#SVGID_00000147909669136887948530000016096574580222458522_);}\n\t.st25{clip-path:url(#SVGID_00000105414622580770266560000004879909336594679948_);fill:#55BBB1;}\n\t.st26{clip-path:url(#SVGID_00000170995713806745450390000000722622955243433113_);}\n\t.st27{clip-path:url(#SVGID_00000042738505107931004720000014141650506241060248_);}\n\t.st28{clip-path:url(#SVGID_00000023252657636424180220000010006036304350814851_);fill:#55BBB1;}\n\t.st29{clip-path:url(#SVGID_00000141426273745911164200000008307944094288647070_);}\n\t.st30{clip-path:url(#SVGID_00000005982926004579438820000001872100015361086399_);}\n\t.st31{clip-path:url(#SVGID_00000183238458146740349780000003272857215263992962_);fill:#55BBB1;}\n\t.st32{clip-path:url(#SVGID_00000176731699273474846860000015043767337304008088_);}\n\t.st33{clip-path:url(#SVGID_00000083772117165700831760000010821912594644178586_);}\n\t.st34{clip-path:url(#SVGID_00000148641364723008236780000016016036903848568231_);fill:#55BBB1;}\n\t.st35{clip-path:url(#SVGID_00000158011604504395468160000002163821338878741148_);}\n\t.st36{clip-path:url(#SVGID_00000069372172784409084190000007137783305525486753_);}\n\t.st37{clip-path:url(#SVGID_00000106870209181619478770000015271172704731571888_);fill:#55BBB1;}\n\t.st38{clip-path:url(#SVGID_00000095314077673977465610000007183687016037844414_);}\n\t.st39{clip-path:url(#SVGID_00000013886364507281116980000018197459300708817299_);}\n\t.st40{clip-path:url(#SVGID_00000111885591200284673210000002769775317344280489_);fill:#55BBB1;}\n\t.st41{clip-path:url(#SVGID_00000077302380018404563370000009436408268012326590_);}\n\t.st42{clip-path:url(#SVGID_00000125569155462991838060000015532136347033891508_);}\n\t.st43{clip-path:url(#SVGID_00000123420792862356249490000016897202704843277230_);fill:#55BBB1;}\n\t.st44{clip-path:url(#SVGID_00000163758384626535789410000016143670132050344084_);}\n\t.st45{clip-path:url(#SVGID_00000169539493554933444150000004770153063960158895_);}\n\t.st46{clip-path:url(#SVGID_00000163783175643230707170000014167934192985289405_);fill:#55BBB1;}\n\t.st47{clip-path:url(#SVGID_00000140000739629303673520000004574663658700361861_);}\n\t.st48{clip-path:url(#SVGID_00000057134049371872899430000004358565356092759174_);}\n\t.st49{clip-path:url(#SVGID_00000092444926955948476080000014289085691733373596_);fill:#55BBB1;}\n\t.st50{clip-path:url(#SVGID_00000123434399294984731100000016193495517630116484_);}\n\t.st51{clip-path:url(#SVGID_00000072270949027963797950000017382225095956035487_);}\n\t.st52{clip-path:url(#SVGID_00000091000616530254459900000012619073704163489947_);fill:#55BBB1;}\n\t.st53{clip-path:url(#SVGID_00000152973134156896286710000003960648690606477995_);}\n\t.st54{clip-path:url(#SVGID_00000077286311775684205450000014877447508046896559_);}\n\t.st55{clip-path:url(#SVGID_00000145770758798241233640000000742239493640812968_);fill:#55BBB1;}\n\t.st56{clip-path:url(#SVGID_00000000183401516824946360000003401503792737474740_);}\n\t.st57{clip-path:url(#SVGID_00000183944701748802918620000000066648780728313002_);}\n\t.st58{clip-path:url(#SVGID_00000078007126408886219050000012702981644575545490_);fill:#55BBB1;}\n\t.st59{clip-path:url(#SVGID_00000063627270963993733630000013385463979776788367_);}\n\t.st60{clip-path:url(#SVGID_00000119828380103121173690000009858480898339623606_);}\n\t.st61{clip-path:url(#SVGID_00000133488211447750716420000007299810079731508380_);fill:#55BBB1;}\n\t.st62{clip-path:url(#SVGID_00000034048331799093078370000001577916012065095349_);}\n\t.st63{clip-path:url(#SVGID_00000068668122406205823880000012917896442660220585_);}\n\t.st64{clip-path:url(#SVGID_00000131344949536989284740000003699374686245405087_);fill:#55BBB1;}\n\t.st65{clip-path:url(#SVGID_00000052081569098006295520000000656075049042247357_);}\n\t.st66{clip-path:url(#SVGID_00000163054555389009622460000005622340140064088207_);}\n\t.st67{clip-path:url(#SVGID_00000039097927180789586620000012404581879566203015_);fill:#55BBB1;}\n\t.st68{clip-path:url(#SVGID_00000174596326588536412670000017909972881262897079_);}\n\t.st69{clip-path:url(#SVGID_00000036224315384122714380000010939138892352745623_);}\n\t.st70{clip-path:url(#SVGID_00000003791709084864806370000014012632009912633488_);fill:#55BBB1;}\n\t.st71{clip-path:url(#SVGID_00000082342588189683975850000008613855119354409120_);}\n\t.st72{clip-path:url(#SVGID_00000122704069653054919590000002534715236911644850_);}\n\t.st73{clip-path:url(#SVGID_00000147187352498934839680000000027334776761543318_);fill:#55BBB1;}\n\t.st74{clip-path:url(#SVGID_00000036224830036647628810000008009974336850140318_);}\n\t.st75{clip-path:url(#SVGID_00000095316976242341847860000015970280708035635366_);}\n\t.st76{clip-path:url(#SVGID_00000164508051185087127550000011401598053357788073_);fill:#55BBB1;}\n\t.st77{clip-path:url(#SVGID_00000113322647570672529340000014473638016670429569_);}\n\t.st78{clip-path:url(#SVGID_00000011016575565610171080000005745603573546883473_);}\n\t.st79{clip-path:url(#SVGID_00000027600964506454186190000015737197462973314468_);fill:#55BBB1;}\n\t.st80{clip-path:url(#SVGID_00000003822641920222814340000006844676201053139608_);}\n\t.st81{clip-path:url(#SVGID_00000139982547674105571460000007373541776964160923_);}\n\t.st82{clip-path:url(#SVGID_00000035527078593973638120000016355160387691824540_);fill:#55BBB1;}\n\t.st83{clip-path:url(#SVGID_00000006687498830599021620000000523210976263461529_);}\n\t.st84{clip-path:url(#SVGID_00000072275278844051664250000002273243096807137427_);}\n\t.st85{clip-path:url(#SVGID_00000106848381514512271810000002259836377454591623_);fill:#55BBB1;}\n\t.st86{clip-path:url(#SVGID_00000071543633694053940360000002569754336141626000_);}\n\t.st87{clip-path:url(#SVGID_00000071559176249358779730000015791183570582804389_);}\n\t.st88{clip-path:url(#SVGID_00000150814935066970257370000013308684311143890079_);fill:#55BBB1;}\n\t.st89{clip-path:url(#SVGID_00000015314102718147842530000004562875374403156412_);}\n\t.st90{clip-path:url(#SVGID_00000035522443317061123920000009152655363383219099_);}\n\t.st91{clip-path:url(#SVGID_00000070811667433404960180000005991385306525994403_);fill:#55BBB1;}\n\t.st92{clip-path:url(#SVGID_00000045615880568484621190000015461526127350241180_);}\n\t.st93{clip-path:url(#SVGID_00000170241543384287779230000010294811990057361810_);}\n\t.st94{clip-path:url(#SVGID_00000124880759368425049110000004728396665593619346_);fill:#55BBB1;}\n\t.st95{clip-path:url(#SVGID_00000124132713388043124200000005184094346154781081_);}\n\t.st96{clip-path:url(#SVGID_00000146498359738951986980000011278468997210639749_);}\n\t.st97{clip-path:url(#SVGID_00000002363507371911518510000001378123450745138093_);fill:#55BBB1;}\n\t.st98{clip-path:url(#SVGID_00000127754153950083427340000015770961980373191319_);}\n\t.st99{clip-path:url(#SVGID_00000144330350335807787720000011617082264636613520_);}\n\t.st100{clip-path:url(#SVGID_00000179642528726099669950000014553858566954442911_);fill:#55BBB1;}\n\t.st101{clip-path:url(#SVGID_00000111164161789461501290000004359788967553298859_);}\n\t.st102{clip-path:url(#SVGID_00000073001066300749746310000002500473285288763834_);}\n\t.st103{clip-path:url(#SVGID_00000183959024952269006610000017300460583807927997_);fill:#55BBB1;}\n\t.st104{clip-path:url(#SVGID_00000101803467088786004250000012223215503194844555_);}\n\t.st105{clip-path:url(#SVGID_00000103223880464193588040000000835285120685564321_);}\n\t.st106{clip-path:url(#SVGID_00000027588764002632623100000003532822083079612351_);fill:#55BBB1;}\n\t.st107{clip-path:url(#SVGID_00000113339246179558161680000002359310924000189340_);}\n\t.st108{clip-path:url(#SVGID_00000116957045613703508300000004514773743741238456_);}\n\t.st109{clip-path:url(#SVGID_00000071524989778714519830000008595813615969700255_);fill:#55BBB1;}\n\t.st110{clip-path:url(#SVGID_00000106140497468909143420000002549522700176052097_);}\n\t.st111{clip-path:url(#SVGID_00000099628777323831226200000005995761272825544870_);}\n\t.st112{clip-path:url(#SVGID_00000080174798014871232280000014944305376019400624_);fill:#55BBB1;}\n\t.st113{clip-path:url(#SVGID_00000107569621303247825520000010993668966896624815_);}\n\t.st114{clip-path:url(#SVGID_00000024693103064341925120000006390559805046931614_);}\n\t.st115{clip-path:url(#SVGID_00000133524417654459274710000014860266985637191053_);fill:#55BBB1;}\n\t.st116{clip-path:url(#SVGID_00000090981839593073255500000003483754325189597332_);}\n\t.st117{clip-path:url(#SVGID_00000041989139252335227700000018186153374382769799_);}\n\t\n\t\t.st118{clip-path:url(#SVGID_00000120558288287758099430000007184525726466982538_);fill:none;stroke:#55BBB1;stroke-width:3.2732;stroke-miterlimit:10.0002;}\n\t.st119{clip-path:url(#SVGID_00000178911659756489185900000007292127420079927984_);}\n\t.st120{clip-path:url(#SVGID_00000131368211777756449740000007518277774036089745_);}\n\t\n\t\t.st121{clip-path:url(#SVGID_00000072259407190629817680000014327756006969128370_);fill:none;stroke:#55BBB1;stroke-width:3.2732;stroke-miterlimit:10;}\n\t.st122{clip-path:url(#SVGID_00000125603262463607444870000001251873557788398505_);}\n\t.st123{clip-path:url(#SVGID_00000078734464073299345120000002753373457399204225_);}\n\t\n\t\t.st124{clip-path:url(#SVGID_00000178911271103927705690000004079123414094886044_);fill:none;stroke:#55BBB1;stroke-width:3.2732;stroke-miterlimit:10;}\n\t.st125{clip-path:url(#SVGID_00000103985217957449992280000017710995986927267725_);}\n\t.st126{clip-path:url(#SVGID_00000137117510171500716300000015352090875329900460_);}\n\t\n\t\t.st127{clip-path:url(#SVGID_00000079486135615737773560000007909796201183472564_);fill:none;stroke:#55BBB1;stroke-width:3.2732;stroke-miterlimit:10;}\n\t.st128{clip-path:url(#SVGID_00000006672372424476750050000015187659866267298717_);}\n\t.st129{clip-path:url(#SVGID_00000047054996195014835890000004200112768233185198_);}\n\t.st130{opacity:0.3;clip-path:url(#SVGID_00000173134603701098126580000007245934467202651048_);fill:#55BBB1;}\n\t.st131{clip-path:url(#SVGID_00000089559560622544855210000000549246373904313987_);}\n\t.st132{clip-path:url(#SVGID_00000018220478599770331490000002032685749590072982_);}\n\t.st133{opacity:0.3;clip-path:url(#SVGID_00000065766557736526650840000016027450743488557958_);fill:#55BBB1;}\n\t.st134{clip-path:url(#SVGID_00000121984372946430012480000003728721422457612987_);}\n\t.st135{clip-path:url(#SVGID_00000087399685854160982400000012699685189371021697_);}\n\t.st136{opacity:0.3;clip-path:url(#SVGID_00000036244981424417655850000003519301659154460091_);fill:#55BBB1;}\n\t.st137{clip-path:url(#SVGID_00000160885110344702490920000009001787869815089824_);}\n\t.st138{clip-path:url(#SVGID_00000027599928109152914130000010934437301858657467_);}\n\t.st139{opacity:0.3;clip-path:url(#SVGID_00000124870328236688071000000014436316006796661950_);fill:#55BBB1;}\n\t.st140{clip-path:url(#SVGID_00000178912295273292429970000013948768430592486590_);}\n\t.st141{clip-path:url(#SVGID_00000127029123480173619360000011963718898090499474_);}\n\t.st142{opacity:0.3;clip-path:url(#SVGID_00000112633700435382014680000003342629705978672059_);fill:#55BBB1;}\n\t.st143{clip-path:url(#SVGID_00000145779696637059807980000013158461448390997421_);}\n\t.st144{clip-path:url(#SVGID_00000068652074566390861290000009639125824634881704_);}\n\t.st145{opacity:0.3;clip-path:url(#SVGID_00000164479918246757858080000005543380826652035733_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 198,
    height: 185,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMYAAAC5CAYAAABz70BJAAAACXBIWXMAAAsSAAALEgHS3X78AAAg AElEQVR4nO1dW5LrOK6EXL2n+Zg99WLunvqj99Rl3eiKogOVzkyAkvw4c4QIhWQ9SABEAuBDcpx0 0kn3tJw6OWkr/fn3X7vs5//+89/1XZV/AuOkNhEgVL+RGBBu594JKCcwTioJAKGO8ZqibPwIhLcB yQmMkyQ1AIHnusBY03G441cB5ATGSXc0AYhFnGPEQMBAcnffK8BxAuOkHyRAgftL+q2iBxIaPIKD gSVeBY4TGCfdKIFCpUgICHa+otWAgZ2PV6RWfzyjkpPenwpQdLZo9DOY4V+/n8nXrvDMAlHk4XRG jJMYKNDQx3YpABLGplgqhWBg5+8iyDOixqVxz0m/Jw0gqO1DnFegydfZcx9FGTH2eycWO3RGjN+c RLRg0aFjtFuGa1nEuJooEs+IHGcf4zcmAwrl7R0wujSeWVOdox9x/d4usM/0lD7HmUqdxECRAaBS nMuGaBHwDCtT1YfPPzSlOiPGb0pmvoIZP+7xWbm0g9TBIsUCkeHyfW047hxF8PmH0Bkxfm9yQ7OY PiEo0NDXlArhlq9Fuj/XryKSGwF7WNQ4I8ZJqk/hIsVCOtDsONL9Yz/AcSHe/0Kus/tC/D6MTmBM 0CO80zPG5M1y8VlQsCjh5h2wzrxd0/FqwJHTqAWuP0x353CtoMa7B9V5Raoxf5zfChizABB5Htdw bmF0uBUoIhk/Dqc6g63SpEjgwPI/RXp2A+jRDuaMGIQK4+oCRhGG/5wm3H7/y8NMY0/wnAERJDJk UFxIWW7WOneOWSp1SfJfEg+KRxfZMj+H09n5BiqWXGNDuZlctbmO5Y96uqlbg+dOunQRoEBDDAKG K/HqzvOvyvMzPRTAeAidwNCkPJgyrgWMSi2VYKkLesjbcQUOmKSr+g5sGUa1tAN1gAavgIDXGCDw OAAcTBaU9SF0plKJhBEyYwtj0Ox3iPQJx+rxOqZdHaq8rAO2AkWA4TNQXMG4mR5HHTjylDvfLqVC nWzRT4vOiMGpynHVgjjngfM1lrJcoK4bqahRLOlgESDXj7PMHwYkUYxEscig7vks1kMFGP4g7O88 NHqcEaMmlaernNc11Eq8Hc74XsEYK6/IvGo1WcZSu/wby0ODdcO0iteFyDOGYlnUUJEBrz2ETmDc kwrfyrCCGJPzYGhEC6QhFwDLLO/K61/gHgWWzD8zPvTsd4DA0bTvyJYNHwGC+ogCFA+nM5WaJ5Wr s21mlKoaqXLk6p7ho4qGrJ+Uic4npHMIBDxW5TJ6KEjOiOFJpUksp4+0R4fDjOuaPORnSinw/q9n zMCA4g/nJaq0CeVg8xAoQzud+RccEDlm6SmRYtAJjD7taUw03jUB4fptvCN9yiM7a+pzqJGeIAb/ kfaqc4+pEwPZQ/P4d6YTGH1ynk4NNyIpw8udUDTQizFQlUKxvgbrEylZKlKRRZL42MIMPRWkZx/D E8t/cQiSDTVWqUanL+By/m6fhoGCGaaTB/lmx7dzLOUzw8p4rPhj5EbAdtMZMe6JeX83oaSGV1fR b8B7gxh3pHsqQ8V0yg3Fqr7CArwHyIE8Mr5vZfz5919Mrw4Uir8AuR8KhkwnMHpUzSdgCoQpEiM0 wgyiSyoH5zoyYd9hBhSZd/db1auM2qWTKu3rRjQ8fhidwPDkIsUKhhkkCgSAAyMRGoFKKT4EOCpD Y/WwNE+Nhrn6MngRyC66scjG+FVpLJPjcKCcfYxEZLw90m+1tT8U1mhANjm3ZS4it6sDBeMXV7xi OWoEDJe/qN+qL4S8In8oQ0efm+mMGDWpNArPYZ8E0yplaCGew3tZxGDzECyXRxkqoLpBgwDg5eHm PLTMoqGLbBh58zGmlA9Pp05gaFJGyjrnjHLDsfuV8UQCAvZDkNDTsnVOuT7cO+NiPCPoRn3XZOxs MCIEMNiIWe6fqej78D7GmUoBibfm9jaE89Cqn/AB28X8vpiXjBQ/zNBY+qd4zMbNVumylIqlVYxP l+oxsBxOZ8QAKt7J2EOYzqiOdoj7FA/Ko+M1BXgEgCK8liPEmo5jMu1j0WIGCIe/7x0nMCxVhoie znnoTj3dZ1161enEKkNzfSB3/pLKqlJMBgiUSb3dVw0OHEonMBI1/jiFeTt23XWKA8pWv/HaFepZ TblVPZkyyJT8ilf23xaYjjnnscD9rF/hZuPPVOrRNPEfEfk86zwqsKhyghgdIzYX0o0yzptXv909 uI4LDb3D1yCMCp1h8Id9l+u3B0bjP+fYphblsd8dgCFVuX6VsoQZFXOjXFiH4o31f9zLVfl+5vUx Qrh0isl3OP3WwCg+bByNxXxscsoZvztfkfLazNiwzApEszTKymC7QLoXBEBo2Gxzn9eJZ0SL+J2B 0fwjRgaCKjVyht8BBQOrMwBl8CpijN9oxKzcWTApkDJABIkUnVQKy3sIHelFfhna8EeM1eI8B4QQ 97hjvBbE67Mo0DFKd85FJUfM0MOAAH9jpHD9iq/9o7/5+9sBYxIUFSBUX4Lt1Tn2+0hyIzld4+r0 ZSrDd+cZINjyj6eAIn43YEyAApcsdD4WwKID1sV+v4KcYeG1PaBA42bn2HAs+wbu00ARz2qkiS+H K/qhjC3KaYKi87KP+4CAA0RH7iMbvavjLXXO9hlUhMBnVF/iqaCIR3a+J78YPlv27XhSWUeAgoGh myIpXh/R4KNMpWvXf9gKFpc2VUBRneungyIeETGKL29Xx5lULkyPneIa/07qQFF1tjuRopvn5+MZ Z1IZjStrSxSrOtdsCQfrXAf53u0dOJ4NijgSGA1AzKQcUYRrdv2LxFfwWP0VKGaGZztyMGNCOTJ1 UzFnuOw5FeFmANLpW6xk2LXzvdp4NSjiKGCY/D3vcXbYNYpqhOgqFEiBgoHgKFAgf8oz5uPZqMrq c3pAnmcAHs22UMBQIGHlvgwQg3b1MRrLKaKxPMIRU/p4HpcgrN/nlbdk9W8FRQfUGRDMkBifayp/ FfpZUlmqTgY+pQ/Ui6qX8ap+z9APXl8NiEGbgbFxjZHyUoqUQa3w9tjaNKYwhq/em57h3fHrQMEI y1f1KoegomoVPSs9HgWIt6YjRqWYR57xugocXSO7iOjB+HOgULwhSBTPFb8sdVC6xHMuSo3oiZHE pZtK59cJcCxG/8g7RkJX3ltQ5bEpNTq0yuhYWhVQlvN86r/dKm+seMFXNBX/KCuSSp8Yn0zGCqTM kaCxd+vEctzwtJI3JmTu9DPeLp2aBsbOoc9oKn2Q8n7VSAeTk/HWAUbFb2UgmU+8n+lQ8ePqZ3Wr jwkEqbcLxqp9VJSslpK/HTimUqmdoGAKryh7x6y8S1LsJe07RtD1zltBwe5RYEW+2AQi3q/KwdQH I8tiUhVnhAspu3MtYCl6PlY6fZuUastXQpTnZ96YfSViOkqBd+98ccJtM+DdAgqX0kWDLxfJmA6i eE59kWMmWscGeTptIJ1k96+cH0XtiGEYdXl7Pp8VGRNeAT3iQv63LtI9GJY7RngkKBT/SjbkC6NG OANKkRLPYRRl/7PR8dxs7+RRMlbHrO6X0WzEQAE7uTqCAg03553sra0VDDxEHQyU3Yk615BIypOy DnUQPli0Uw6F8aiikdPJEvxbVLl9lKxVxGDyIqhd9GL3f9Ero8aW4dqZEJmVzow9hMLRU7Hj3M8I GDZEwHfCO4KYEQMDM1TWoB/ieq4XUyOnJ1YnPreCLlfxPPKLHjyfc1Eje3ocxsU+xpD7Mx1fob6X RY0WIr+Ry6IFegL8v7cAARk4qtw1QJmqzAySnNqoKOciCtNNFxSZf3ee7dF70hEbURaLLvJlnw1G V+knEwJzJaNS4zf+7zduLxmhmo0YysuyFGbczwwJDVk1OOus5+iB3mtEEeb5Hci6jT4TKZihsnvU vUxfKkqsIiW6QFkBZahoXV1julcyYsTBaJEjCdb7sqixdebbGVbHq68QNldQdFaSAlwQI8MPgCHP yL8qJ5OKFEwnTDdKb6peNFx0IGiQOa1kdajyV2gjRsgLplMOHJHa7Arn0LkFOXe71ulrHB1VusBQ nrAzDKgAgeAIOF7Am+SRFuQr86Ny1HwPk4Up34GClV3pwgGD1c1SjCAgwKUcWDYadBD9OD7w2EXt gHvYMdsYbyUgBqW/Sr7RHrCUFaf+RfbaS+pTqBGVwVQ1+xlF7sz6Mix6ZMp15zKZAWOHd5ACRSfP d8Bwv53OVpAnoNPe0Q3yrn7POgJWFz6v+hjst9K1IynbFoDMDtcOYkYWaY/KwIjBviGkhmw7SlNe CA0mRANW6ZNbbsLqV/WwxkN53JISd65aDsJSNKUH1rYV36o8FTWVU1Zt6TZW1+14y7DvlnmMihFm ZMw7fH5v7BpeV+CoeGMbXkf+M98hZrQxXXGgYMbsthlDr8BTOZ1KJqUrJZvzzM5WOo6t2qxzmgXH TOdbCYbMsNTDbVEotHo2iDK6oZM1OPPejkfWyLkstsdnVf0sfamo0qXjf4VUmOmSlbGS/p2qI1LZ QWbp2Qy9o8znCuUrGUrqRgzW6FVDIaNqtefX/t88kPw5ZAUI5C17GuVBXBjPVHnWXL+LFCoiXiFi urLVfAtbQqIiCUZft9IAZUFSdWC7q3JcdFeRAf9hyv3hJXVWM1Fjz8w3HmfKimFe97bHjtH4/f2J nAWemfXA2ZMoL4Z8KyBkg2HlMfk7oFpJQzIeMSLjNeaVu/paTYedAY6VFWTUsCLlcFdjW0gIzIBZ 9E2R45EfdVYheDqsgfEwb8RSKTQ6NGzHrzPonDY4B1GBg4FCgaRjICqVVABhqRPyUemqAocDGdap 5FR6wGxkSREwyBKTKdo6KtWlTUxtIJXnqxTKRTqWInS8JSPWGWbHmTCtUIsNMc24GIOMVKca4evK hvy7VFCVVaW/mD798b19kD2mVh9Q7o9276ZTj/4bgHZON1kmSyMwz1aRo+LPpSCsLJbC4H4l3ovx p4DrPKozZJeGZnK6mY0YLCqy8lydyrCxzDXpbkQKXGayyTk/EhjIVCc3d2Wxc8qYUHkzCnIefRUN phouP4dlsFQMPaeSXfEdwHNevep4QDkdKFmKhUBw7czSKxU1lS4wjQrRNgiqNki2pFLofSoPxASz oY2s5g0jtDJSBRxlcEqWmFFog5w8bNk+/lYrDba887DFSQWxgRk9MdtgMqr/Nu+kl0zWKepGjCol cUrIAn/CufUbHEp5W0HBylMeEeVE0DNvxuSr9ID1q62apVe8YD15fgDXm0VTH1gmRplBeIxRA59j 9bG2Zoau6skDImhj0zSTSqFAzIgWIjwKek2/FeVn1Th15RFnUyiUlZHzRIt4lhlDXuPEIkOQfZdv rAf7L2olLrZXgP4cCDv8MD0oPljkU6Qc49Zo+EWzfYxVbMojIIIxdXP5KFMQMyTFZy6n6oy7BmYG wYxI8Y/GEUQnzDtu4Y/xknW+kk6pkkE5GibXFlJRkTkIvEdFX6WDadra+VbRgnmsPK6NE0Aur2fG 46JExWdMKg/BrXjqluPkUqDYmr+z6BTQZmj4FUBQ7zn6M1kZcJxzcuTuxZT3kP5g2fmGZRpslAa3 QR3vyNIjNkbfiRZHKsgZAxspcVEjjGwdUKxp/sEtrmROgNX7QRxNGBlYecw5dMubAQPulb1tHQiQ NNv5dgxiTo8Kws7ghTwb6RlnkGiMuW6mEJUnO2LpA4tgrJ5MrBx0BEyevLF1SFm/bCQGeRv6drpX bcjaJJ/fo18kZtx4H+rG2eQm2ptKKUZUyLzAeTdl74xI8ROEh1liqYHzkpmHEPMfC+gA5VKgYDPV qKOs0zz7jfwNyiNTjFgbohxuAs1F0HyPapt8/pruX6CNUUcYQVl5bdrS+c7HKyiI5bB57yIMEktD Kg99SH4JfAcYcOYH663ePmPlIP9j+xTAyOXm6HuB80qWIOBg/ObIgvwHXFOZAqZWrn3Q6FVaxnRd vWcyHT1aE3zf/QwVzmLCGHDC5g8yeaM2JFZ3l6eKVNrjPLx7sQj1wKISA8XoT/yTtvE77z9J34PJ 7ry5koMtZXH6CVIHgoXJjjq4Cj04udmneDbRllSKRQ1mkE5Z+d5LQ4gqfcrnMAVQKQHKoupxDY6y qzTKlRmgD3xXYzT2J5Sd0ws8j/ViKqJSk0FX0n5Kh/k38jBDHe+Ous46W4me7myz+/73EWulEBQq rw1jDAg2LJ/VqXhB2tJIgypwo4frGik7Ri+tXi6KpGeVMi0pFVIGrNJSdGoXuH8RZVTAQVKpFQPH SvY4IKFWMm+iIxcRdrx+FUaxnBUU6ACEdeX7uuBgRsT6SiEaYYVGuwD/jg+WxiBQVL8AI9SV6BcN muk7v9yT555cCoZyMX0jCPB3ZQN4TKOBAAXTUUktYOz8uK7LzwdloRYicBhlIVWjMo5P5vXUb8Xf FcpRhsJk70SMLPeQ9QNe1rmAPjvEDC0TixoB93bqc5GC6YOBQBm+kuFrP/MZnRIYxZ/FsPMB54Oc U9dUCI1C8Fyeer1yL7hVGc5TOUNR5x1QriBzBsM4x+aJZmVfQY9dY2eRQcmXfzPZZ0aZJBhmI8Ug CwwBikjHOQ9lUYFFCJaSKMVGusdFjKrx94CCUaV0Jwvek38z78euYx1OL115MGqr67EhErNzKzlm vCiHg3MxrE1ux7MfXZPAMKBQQGBRpEMzoGBG0O1c5uvvQDMpztHXOnXO6qlyBCz16vKCe9axlr+3 fImQCj8BCrXmh62IXRqhGUMo5to5xwxoQORJLbvIndAq7DrAY3qD8wfjufzCDfIWIKsap7+a4dq8 Boq9I+3qU+P/2NasPZHUex4sa1ARwfWrWIpV0d09RwzX7gGFyi2r1ZhKeXguYI9RZ4+3ZKQ8KILm Avn+Fq+byxnHK5mtVk5ARfGqXmXQqr0eTSq9mtVnpjUPJDmQ3HVSxQhUFxQKEM5D4PloKEDl4t38 WqVsinc8zsQcSCelRM/Pots4dq95upXKs6TS4srrq3bb6qBmnnMOwcriRlvVkhCWnnRAgQrElMht zsgZuQjDokrX66i+DCtjyIr66DgLpvNcDn4ORtVRgUMZda43SFs7GSpds7rUM0q3TldB5HP6l9FP geMHMMRfirGKt4CC5bUul9xLztO7Olyjj2M0IKePrJdKLmWc6vtJs1FDyaSiFpNpVl9KbuW82DXF Z9dRuAhCwaEiRpeZbpi9ko4knlOTWK7RGJD3EMtrXTRjOsEXgQL4UtFClcP+bZV9x1X9p3pXJ87j YlmV51dyVvXjcQWEmS+HqDah4Lj9gJEo5TmqUN1FvxMcqWOgWCZGNuUtXEhHPbEGyqTSglyn82Do TNiycxy7Z22Dqdcg5EtF6KpNmJ4YXzNlrMI5Kh7XonxXzwrO98d+dMhxVApRq7w1YwiV5IyNefpK UORthT27bwu5dGCAIdcfsEcjCeC1MzOf67nACBU+g+DogEK1SRTtMFPODK3wLNtXzgrrVsCLpNNV lE2Ha1llznhzwW6FoxIsAHDZKHDPPDw2hGpQdg6JRbz8fF5qEVAmggXryeXNgGNNelmhbqU/jEIx 0S65bJUJdMtgxBwOPsdkxvJYKq+AkYfQr0n/OG9z4yUDg3ldFy2wMAaKajLmkpi9pHIqcCBIAgR0 kYcpWRFrlOx1VLRSjb8KOZGywednMRplPTm5WWqyJ/1xaRgj1WaKmMMJsAO0ywD9Z17HvTisjED6 KUjxB5Qqd0VBUfkdYLhUoDMaggKxdA29KiokRIPjLHYIvbC0hZXD+HL9IPT2d40nHAfKpdqD8eRS sfEsexEIeag6//k5TL1RXxUoHDBmR0O/nv23n1HNfLtogUIyZlS4ZR5tkAqfzLui8TDvggpz0WIR jZ4b8SLucQaADc3Cf5VaqTrYeYziygiY7E4/WR8zEcPRQspwcjqngryyAQu0Fxo1XB+DMclSqAoU alaUefJ8jSm8SqkcODLNplO5LAYaV0/Ac5H0upK0MZOLBK5ObBM2FI5lqDKxPAWKrk5V9sDkxPMI BPZfGAEd60zZsWF0/kGdtVIBlaKQrgGchxrMZWavidGVCICgXcneKb4jaxiFMWewwDV17xWuXcj1 HDUcwKvUsmoTxgcrD2VjURR53BI1AtoxnxuEWYubr1mSrLmdEBSSsPPNKlCMonKYp2KehdEVGuEq GFcKCKJU9GYBylcejhlkxf9MCjIoj4yMuliHnHq0og61sc4nRtksD9Mh8jUDCAYqJRtmLSyFYqOZ ATpFp4tlU1IRw6VTQRSmBL39xpWM3x3+TgMFMbxFnHcGNAuOTkrGeJihzEcGyoXoowO8SGWptKdK f7bK07UZZyu5rCBlMMNeIB1dkx4ZPy1wqDDaoRYgQizvhXPOy814S1ce4xOfZY3bjZiKF/Yc8ok8 s84ypkXunq7+mGzOCeKzbnNldduk0/ZH0F37bP0DfCbEIwVh5SoPxDr7KiJV0UJdzzx0UzMW5Soj 3KpPZlgsUpa5tignmvphz7sI1uGDyYFtezcEK+wFr93o0X9OeTShAKiAam0NI5bDq76MCuW5HiwD 63Z9OAZeLFfJgMSewUlJ5vG7xNIcVg6LiM5QQxh9BqRaGpPrdNlHCco9/6iUmXoGsciUowQKf23w 6Ax3Ke7pyI2pWeZP5b9KTjynDJPxUP2uUkYXEbEMFg0VOKIxnK/KzWXiPdkm8mvR7QGhPX0MZJ7t v8j8AWUup5OHB4BBzWSqlamVJ85yuFW5eL8qaxGjJ27GOzfuSmRQ/QvUE5av+OisMgjBp+IdjTcE r2q1BLYl27Cd1bds3RSCBIiKGCw/YwaRvVfe7nI/88oslutmMpE/JahKo9RwKP4ez1+E4hhvKAem LJ10SN3DVhAoj8quubpdOUGeVRGIOQ5VRpXqIF3QnlJbdtZKKZDIujMw0JiZQEgLPKM8iHs+zEsk TFglOMsjq4bORtNJJRjvqC8Eg9OBu8ZkRf6RP+W5MbIx3rqgqFLPjhwqcij5UDY2KRzQDpGudyee V/U+BgMFCsGUuSRG2Qs8ivB5F9ZZxGCffWfRYiFeJ5dZGXYup3IWmVSUZMcB/OexeMZfwLWuY+o4 gj0yMVLRvhPxlWwr6Af1hJuyFRqpWCq1gkGotAQNJmCCKj8TQtixd3k38ham/4D8Iq/ISzeiMfmR lCfOZalnUZdXeMY9h87FAaOKYHiv8+IBZaHTUI4KvTkDCPKLdsfWOyknozIL7HP+kNGNSqEQKwiP nirEuwadZytQIB95xMGFRvY8RoIgfCGpSJPLZ+XOAE9FrWwIK5Sd9c7ezVByKJKGYvgO4Jc9h7xX USPfg7rI51FWbJ/sSFl9Us6bgH/+/VdWbPbg7At6OAWPlXdmYJmnY2+ioXJxGM4NwS1CHjyH9bmo wI7v9Nnw8u7ZjjeNQoeO9yCGx+7Bc500SkUFFuXdaBEjdMAMFIx3tEMExdc+r8ZgnW8UbuRxWCBL qQblN/MqQVmkUKkYixRZsUgYtZiysB7n5TEaqMgRRma8toiyVARRUXcp6mbt4HhkfDL+1P3M2BHo 1RAqyjp08WmiBeNHgoGBIhrDtQsIwxSPzGUDzakVIxb+2fsJTLlO2Ei8Y/hl5wLOY/0B5QZ5Nsgx I8VjgEPI11za56IU0xHyiU5NyVudUw5H8aEcFeMXnRFrP8YrK6PVVqrzjRFi9BnyMBkyOo5VPsy8 D/N6QQzOeRusq5KHgR7vxWNGVfRA/l05Y8NRKGx0ZwjMkURDR51I0L2ey1ed6U6bfdHw4mkODJ2X q7+6RiPFoB9CwrvfId5xXuDNKfTwTBGMMQQFns+gXCFtwk63WjiIaRqb7WVDxFWIvlNwQ3ZnlMin q7eKaCEMsAtOLNt5ZOQJ66tmtlUbUqMlqyW20K1M91Fnl0ph2BqM45AsiyK5DJf3OkCoxq3yUSZL JDmqqKH4U8Q8mPLYjLdRB47JK/1UaUwIXaEusFwWIfeAompHxpc12nzuz7//Eux42vM3ABiu2NBr BklAozKAhFGsizTK63S8IUYPZjRBgM6e6aQXzJkonly5TB+d6IC/1RCok2HmWhUdu5udT1C05c9g ZuiHMaTKkFE15Oa+O1uF7yD3sXCrhvSYQhlQHJjchqG9koX1m5ysijeUS5WVr3Xy/sqRVPK48rMT ZbJgu6p2+qJHG32H7lbXkjfrBrE8URkda1xHVTlXsXwYeUSqopA6F+lcNOuaJeVlHal+EMqIsign wmgGCB1QuDmtmYj2VKpmvjGdyKNT2aOspAO7gpJZI+Kx8jSocPYcjmIg//gMG1bO5eXcH9/Bdmnh KtKhIPpktKY6sUxmOCzqVcQA1unPKHC5SKE2mkK9Q7QI9T4GSamUEtxsJnoKd57t1Yb83CnU8M82 NULCwNjxbNmY2GgXzkx3UiFl8F0gsBl+tyk+GD+uvZh9IM9vEyUyyReVCuNCYfF/Lljfo+tFMnUM 8Gvf/JN+F4064JgJ+zgczQCCy1A6HppFh66eKlAwfbF6VGRQQHBtfyv3XaJFdIYji39wZYpV51yd MwagvHfXOMZx9VZd17N2PGwQvvMxiyAOMFvqcvrodLSr6KucjEuLb+W+Eyii82prI3KwzriKHMp7 BByHMQw1EeYMiNWhGrbj5RRwM6kI4SYXu5N8ihD0bA0ae+/F1dWRXQ1mKB1iu7wdtRUvZh1dFOmc d6S831pcc0p30c4ZqXrPga3rcumQ4kvxycpTNFMPltmJ4iGGsDuRIl8L3L9btIhZj2Sm5DtAmEmv WKO4CDMDkAocLp1iXhYj1ayXd7SlrCONTEXXaPQvfllQxNZGbAJEgYGtpWe8KHCEmXzD86wslc/P gAOfRdmVTIzUPTPldNOTjhFiWQocKmX65UERe71bI71Sy8qZ162o00jMs7EoUoFDAaO72FCljJ0U Zk/0qQDSSbeYU8k6dKN1/xOgiKPCPvl/8DCGprxvxU8HFK5jH9DgHXBUwFD8K8Xv4ggAAAi3SURB VAB0o4qLImvaBxyjrtg5F4nV+Urf3aHtXwIU8b18fBeJ4dxx7HJ0d01tQe7HOtGTI29Bzmdai/tY yrek4xCGyc47h7DFaVVRAg29uicMKBwwfmlQRGe4tkmsgREE7I/cxzX23ofaGMDYECQDD/LI0rNo Tlx1zs1EMpfCBBzjb7wX73FRtZrkVLqoJm4Zz92J2JfTUX0M9NidcXrm2Weo8mDKMEMYUZUKqqin nmV6YedmollFXXAEHOPvTtRgk3VuEpPxdKN3iySbgWFSKBUJGDCQj0o5LJ9WHtANH6q6uuBAUChj z2V174897SJkU6Bw0Ys9qzb1XIe3H+feehHhBHUNiKU5+bmqMfL5gDJYylX1WW70b0M0Fh0y8H3C bzbb78pw3njv5vSIPDNnUq15YxEYDdrZhHIeb5NqbQKGGaZFMLDUI9+PylUNkI8jPTdTt/XK5iUt ZvwIkJn+BZaN9Sg9OAPtGG8Ynjq6V30JdFboDDsOKz//FuDYxAAZnmUplIoUmDZ1UpxQSoT0qtvQ 3ZQqoJ4wjaqudVa0dlNJpZcVfiOxaNFNj3CvIjirfyH3hqjnrtxXplWPSKWqVCaSEtSIB/uvA+a1 RlmqfrZ9kK8rVkBmcqIOnH7wHJbBUhHl0dG4VVrjwLLHI7voPLYPsVW6/sHfKyPHEX81xoxIRYko QKG8uPPAF7hv3HMl14ZxRbrGjBLrjoOMq3pGASQEj0y3GElzRFnIfXhPh3+sJ0R7s+wgCKBHmyg5 n05bgYHortIGFLrr+YKUjQaPOe5otAtcu8LxutEo8NjdW6VQmVQ6E8BrxRcaJpMRwYJAUXWMa2yE rZIR2z7ASSE4uu3yEJr2evBRNkxd2AegFxASQaGAgYThW82VYGN0Jq1miUWPfK4zqx9JL51cv4oY XSNlUZr9jqItwsiH8zus7T9hn9vnh8yv6Gsc9a+trIGCGJDKmdmoE5Y/KHuWS3r+g9wbEDlYBOkC pJNKVWmFixjIC/J1FWmTKk+1AUuHnEyuTDbiyFYb5EiT09mx/4RnMJo9nfYCw3knJijzTgiQMMC4 kLCLKRSey2nIFfZ7ogbjbxCmGm7YGAnz7vzbAYp56gAABRgdEtMtypl1zCZwFTBWwsu4Nvi+Qlu+ LJXa08dAAVXUGORAcTWgCDDsSFFAGTamcAiOIM8ekVLheQUK1uguxenIGan/hVG0w/OgHGHZs+ik Mvg7aa2yC3SuLwNFHDgqlY+Z4EGM0OXTjtDbX40iERzX1HBogJXBzOgjGw+jSg8IEKWXFQwzkj5Y SjKbOuF9aLxquJbZwZWc70TDl9CRfQxHuVHVXMRtb75yvYKh5/vGb5e2ZG8aJPIcpYsqegbIzAYh WNRgdQ26AjgGXUBv+VmXVimZGDCqgZDRLldTDkaNl0aMLRN8Vfqg7mGGHKgA85VrBqLKqFWDPmOr 9MCM34HCRZSZ51D/KhpUGxtpU6kV64soh/EW9KyIoYg1VPe5mTrRez27QTDShTBuNpTs+l4BAwrY ec5URa5B7B7nDNEJLMTh5ijA7ld1vixqHAWMdyKlzG4f5wjKqR/ygPV30yiXSmWDU+BgKZ7isUrb 8F7Wr0RnxJ5V19z5p9BRwNgqBOsgdp+b4YsZ2COBobx25msqfWIpZvrzFDbAgDyofpfiryMjGx1U IFBt0K3vqbSlj9FBuPI4rB/yo6HYwrHGMnfmsVxePrOkesumUqJq2wpWBfbZ+qrzWzfVDs5hvZSe FTEwMuDow4+9WFWp8tmKr1Ev88zVMpS9hFGQeUrVAd9CzAPnNWJKdyqtytfXhjMKcl+AfJ8FKN6C jgDGShSASmdKZRs+i43DRkPU8GA+ZinL3vVSW4h5duQRZah4u3MskOYw/YfRsyKM1JhGjXouKRPB NnFRa49DOJy2vo/BDKoKh8yYu+9CsGE+9wKUaoRP2Ofzz9iu5NVXldoMWeQiOvFKboChoT4+N8jM 9Ji3f+D4Hzj+B85juSrFehntjRgq/1bePxswe2dCeUkcCkQgMb6CKNt5qWc2BHMge/lgkSOfx3R2 hlga5iKVW/rhIsfb0NaIwRpFNfYKCl3AwNHYlfF3IgvjiXnmT8h1j+58s63T+b3TYbXkWvxn4p76 u8+66MGig4tArB2+5HjV663TwIDwzRpTNfQsOPCeKu0KwkdnNGbviEt3Y6kC6inycdcozB+KOkPf Krt6Dg1/JkXD6P1y2ppKZUPPUeGawiqG2kHo2S/pWTQSfMb1LdAwstI/oUGVUT6Kqjp+XN/iJckf c2bdsfK2pFXYlri8fgE7UHUy54T3vBQkRw7XqsiRCUdIskLYArhBKm1ib4qhV1Se6ZnAuNGjUwNS /l19MBw+ww/2Uz5FuzCHFcZGEAytNPKRdETnG4/RsLPxrnDMZk4/oDzW8WPDjipVsPnzr/KR4SNp q8xpph1pBWelohECA8/FO4Aidna+lWdyeW2maqRJrcqs3hBjfQeW3580Sc2Ofref4iLGy2l22O5G xUfXOqNIaNiocAai/BufwYZhx3eN8TtGjL1k/lGL/VZEHeu7tMcRqVQ20jwvgZGCLUVeASjYuUNS QKpAQfsUJyi2kejos7bp0Fu2x+aIEf6flFw6VM0/dEmlTwwUd+PjcQLjUNr61cB3bYMj10qtxGuM aIGgYc93FKs6b5guMVD8KOMExbH0v6bPXTPfjT/HZ50x9XXw2cmlVZSnQHEC4aQ27UqlBu34Hz6V ijFCA6+GYhkozmhxUosOAUZocASkTwwgIQCChOlTZ4sTFCdtocOAETU43AxpBYpBDhiR+jQ4V3GC 4qQpOhQYwcERBiB4DZ/LpPozQQByguKkXXQ4MMK/o417ByIkNgl4hd90ovAExUmz9BBghJ8d7YBG Ee03vPss6km/Hj0MGIMmlg9sWUpwRoiTHkIPB0amAiTqXCZm8CcgTjqcngoMpL1/PngC4aSTTjrp WRQR/w8lveZ4a1kJQgAAAABJRU5ErkJggg==",
    transform: "matrix(0.9948 0 0 0.9948 0.0215 -0.0433)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 197,
    height: 184
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018923710685495511200000015158939310746490549_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018923710685495511200000015158939310746490549_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020385253730061541710000010180371147559040900_",
    d: "M49.4,80.3h8.1c0.1-0.5,0.2-1.1,0.4-1.6h-8.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170278320749292374040000000612122011877270950_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020385253730061541710000010180371147559040900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170278320749292374040000000612122011877270950_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131344259887173810240000002923833118671037317_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100357137114538819850000016221528473458062776_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131344259887173810240000002923833118671037317_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 77.7,
    style: {
      clipPath: "url(#SVGID_00000100357137114538819850000016221528473458062776_)",
      fill: "#55BBB1"
    },
    width: 10.4,
    height: 3.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000048472946685162222750000006491756587226387887_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104702178301830957810000000044913775413832123_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048472946685162222750000006491756587226387887_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104702178301830957810000000044913775413832123_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000175284763602319216910000002318887664603881366_",
    d: "M48.8,78.8l0.1,0.5h8.2c0,0.2-0.1,0.3-0.1,0.5 h-8.1l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049185750926686971940000007805004096053425828_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175284763602319216910000002318887664603881366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049185750926686971940000007805004096053425828_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163755584475390936250000006503862167529980549_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078036433858647659790000005825700107654224005_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163755584475390936250000006503862167529980549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 77.8,
    style: {
      clipPath: "url(#SVGID_00000078036433858647659790000005825700107654224005_)",
      fill: "#55BBB1"
    },
    width: 10.3,
    height: 3.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000112591250742080294600000006607525906566501052_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065042837770707644910000016378118067137656962_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112591250742080294600000006607525906566501052_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065042837770707644910000016378118067137656962_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000208405529072058570000010101559479800187815_",
    d: "M167.4,80.3c0.4,2.6,2.6,4.6,5.3,4.6 c3,0,5.4-2.4,5.4-5.4s-2.4-5.4-5.4-5.4c-2.7,0-4.9,2-5.3,4.6h-9.5c0.1,0.5,0.2,1,0.4,1.6L167.4,80.3L167.4,80.3z  M172.7,75.7c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8S170.6,75.7,172.7,75.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098212220245696220510000015581863111089957557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000208405529072058570000010101559479800187815_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098212220245696220510000015581863111089957557_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013179112471214054330000011283286509405401229_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013153855118308972070000006762316894014777226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013179112471214054330000011283286509405401229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.9,
    y: 73.1,
    style: {
      clipPath: "url(#SVGID_00000013153855118308972070000006762316894014777226_)",
      fill: "#55BBB1"
    },
    width: 22.2,
    height: 12.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119823748454771684470000003757307818274473868_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176043493773312224420000017426983028368223877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119823748454771684470000003757307818274473868_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176043493773312224420000017426983028368223877_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034776217882033851360000016654386236307734450_",
    d: "M172.7,84.3c-2.4,0-4.4-1.8-4.8-4.1l-0.1-0.5h-9.2 c0-0.2-0.1-0.3-0.1-0.5h9.3l0.1-0.5c0.3-2.4,2.4-4.1,4.8-4.1c2.7,0,4.8,2.2,4.8,4.8C177.6,82.2,175.4,84.3,172.7,84.3  M172.7,75.1c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3C177.1,77.1,175.1,75.1,172.7,75.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037650227788916290210000006877428534998922661_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034776217882033851360000016654386236307734450_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000037650227788916290210000006877428534998922661_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000122701065816153071980000015672225083992780685_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159437616116858492670000012483025002110044072_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122701065816153071980000015672225083992780685_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 73.6,
    style: {
      clipPath: "url(#SVGID_00000159437616116858492670000012483025002110044072_)",
      fill: "#55BBB1"
    },
    width: 21,
    height: 11.7
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145750888433170024760000007402364709074430902_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006683802404330705590000011604867061169989297_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145750888433170024760000007402364709074430902_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006683802404330705590000011604867061169989297_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000136385904275772845810000008751016924670159754_",
    d: "M43.1,109.8h16.5c-0.2-0.5-0.4-1-0.6-1.6H43.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077318490295863861760000014785070627976259485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136385904275772845810000008751016924670159754_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077318490295863861760000014785070627976259485_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019647575427014624640000011002224655995003011_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076593860295917413710000005850310198536599951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019647575427014624640000011002224655995003011_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.1,
    y: 107.2,
    style: {
      clipPath: "url(#SVGID_00000076593860295917413710000005850310198536599951_)",
      fill: "#55BBB1"
    },
    width: 18.5,
    height: 3.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160880999418498078570000010972563704008965539_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055690830213425875620000005061764056400363416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160880999418498078570000010972563704008965539_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000055690830213425875620000005061764056400363416_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127034280330035732840000005780176660301176488_",
    d: "M42.6,108.3l0.1,0.5h16c0.1,0.2,0.1,0.3,0.2,0.5 H42.7l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038401106954542406560000013111097530982797743_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127034280330035732840000005780176660301176488_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038401106954542406560000013111097530982797743_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036249932530858791560000017582610157377452469_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039133215688735785820000014453554653314029445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036249932530858791560000017582610157377452469_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 107.3,
    style: {
      clipPath: "url(#SVGID_00000039133215688735785820000014453554653314029445_)",
      fill: "#55BBB1"
    },
    width: 18.2,
    height: 3.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044175363422217625850000009532379171208093843_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000186167508470167100000017745217025673812376_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044175363422217625850000009532379171208093843_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000186167508470167100000017745217025673812376_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000004533152961276322830000017905797930351839617_",
    d: "M173.7,109.8c0.4,3,3,5.4,6.1,5.4 c3.4,0,6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2c-3.1,0-5.7,2.4-6.1,5.4h-17c-0.2,0.5-0.4,1.1-0.6,1.6L173.7,109.8L173.7,109.8z  M179.8,104.4c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6S177.3,104.4,179.8,104.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072985489036348559740000009774596957485253284_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004533152961276322830000017905797930351839617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072985489036348559740000009774596957485253284_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154414195745681934800000012721408744890379938_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158748284802672145380000006280882993564980127_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154414195745681934800000012721408744890379938_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.2,
    y: 101.8,
    style: {
      clipPath: "url(#SVGID_00000158748284802672145380000006280882993564980127_)",
      fill: "#55BBB1"
    },
    width: 31.9,
    height: 14.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016043385325164300830000001838690072132387515_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081627908469105776740000016522192795700582042_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016043385325164300830000001838690072132387515_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000081627908469105776740000016522192795700582042_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065777780897482987410000008367101682494135188_",
    d: "M179.8,114.7c-2.8,0-5.3-2.1-5.6-4.9l-0.1-0.5 h-17.2c0.1-0.2,0.1-0.3,0.2-0.5h17.1l0.1-0.5c0.4-2.8,2.8-4.9,5.6-4.9c3.1,0,5.7,2.5,5.7,5.7S182.9,114.7,179.8,114.7  M179.8,103.9c-2.8,0-5.2,2.3-5.2,5.1s2.3,5.1,5.2,5.1c2.8,0,5.2-2.3,5.2-5.1S182.7,103.9,179.8,103.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074402510942750061440000018363163497392870838_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065777780897482987410000008367101682494135188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074402510942750061440000018363163497392870838_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165228120424189564020000000072905935548598160_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006669097445075253640000003378841513377629109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165228120424189564020000000072905935548598160_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 102.4,
    style: {
      clipPath: "url(#SVGID_00000006669097445075253640000003378841513377629109_)",
      fill: "#55BBB1"
    },
    width: 30.6,
    height: 13.3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155114576813865391620000000458134481172291724_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107551809596535189870000012905873230916316082_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155114576813865391620000000458134481172291724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107551809596535189870000012905873230916316082_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111876574149696647110000006949653586803173784_",
    d: "M179.8,110.5c0.8,0,1.5-0.7,1.5-1.5 s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S179,110.5,179.8,110.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080915205187211496100000015250543924394263707_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111876574149696647110000006949653586803173784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080915205187211496100000015250543924394263707_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052813477859735389310000004665158515102824382_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036210467676612955890000013235803895778741657_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052813477859735389310000004665158515102824382_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 106.5,
    style: {
      clipPath: "url(#SVGID_00000036210467676612955890000013235803895778741657_)",
      fill: "#55BBB1"
    },
    width: 5,
    height: 5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069398605314464937950000017331276621170099842_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030468556165862930470000003889578563317639088_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069398605314464937950000017331276621170099842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030468556165862930470000003889578563317639088_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139264177309575918790000003358922827882867366_",
    d: "M179.8,110c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1 c0.5,0,1,0.4,1,1S180.4,110,179.8,110"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183960012279861917180000015714424456069432718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139264177309575918790000003358922827882867366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183960012279861917180000015714424456069432718_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000156558967312785429020000016127805770332554143_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171710386080294499720000008070388479798572969_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156558967312785429020000016127805770332554143_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 177.8,
    y: 107,
    style: {
      clipPath: "url(#SVGID_00000171710386080294499720000008070388479798572969_)",
      fill: "#55BBB1"
    },
    width: 4,
    height: 4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101097757753468660290000004828137714838921135_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111188293553993677390000004005011804873660571_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101097757753468660290000004828137714838921135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111188293553993677390000004005011804873660571_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031208675620135339220000008455718141624548995_",
    d: "M151.9,157.3c0.9,0,1.6-0.7,1.6-1.6 s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6C150.3,156.6,151,157.3,151.9,157.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085968783919784000240000001573129451905004937_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031208675620135339220000008455718141624548995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085968783919784000240000001573129451905004937_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075136563066196700990000004564755456153361571_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093891878140732434140000009862987596900767906_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075136563066196700990000004564755456153361571_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 153.2,
    style: {
      clipPath: "url(#SVGID_00000093891878140732434140000009862987596900767906_)",
      fill: "#55BBB1"
    },
    width: 5.1,
    height: 5.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143592329141698574980000000530107717572853386_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182523701941364941250000018096311291051167414_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143592329141698574980000000530107717572853386_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182523701941364941250000018096311291051167414_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163062277040302707670000002032411396138463934_",
    d: "M151.9,156.8c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1 c0.6,0,1,0.5,1,1C153,156.3,152.5,156.8,151.9,156.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000921914037602002510000002572466765147404477_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163062277040302707670000002032411396138463934_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000921914037602002510000002572466765147404477_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119838369209521834620000005481306369303991225_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095328286175421953790000008678161281236788617_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119838369209521834620000005481306369303991225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.9,
    y: 153.7,
    style: {
      clipPath: "url(#SVGID_00000095328286175421953790000008678161281236788617_)",
      fill: "#55BBB1"
    },
    width: 4.1,
    height: 4.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127024720745189964760000007486968203412856970_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049919850499970542130000003412120929150967966_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127024720745189964760000007486968203412856970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049919850499970542130000003412120929150967966_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013902381076489978080000008243551946806884526_",
    d: "M75,28.1h18.6v13.7c0.5-0.1,1-0.3,1.6-0.4v-14 c0-0.4-0.4-0.8-0.8-0.8H75.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039838426999529847890000002213599773062900412_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013902381076489978080000008243551946806884526_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039838426999529847890000002213599773062900412_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003799194352667373610000016819697459858782602_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088836964660759276790000001208796844250986928_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003799194352667373610000016819697459858782602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 25.6,
    style: {
      clipPath: "url(#SVGID_00000088836964660759276790000001208796844250986928_)",
      fill: "#55BBB1"
    },
    width: 22.1,
    height: 17.3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088095290144779499530000012394078534951695035_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077307427773675825500000006941990910683896744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088095290144779499530000012394078534951695035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077307427773675825500000006941990910683896744_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103238492869688777290000000071162522751266985_",
    d: "M74.6,26.6v0.5h19.8c0.1,0,0.3,0.1,0.3,0.3V41 c-0.2,0-0.3,0.1-0.5,0.1V27.6H74.7L74.6,28"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108290842110586333070000002879343786922305195_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103238492869688777290000000071162522751266985_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108290842110586333070000002879343786922305195_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127745683719352404640000013488072580357724576_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078022253691655354530000011228213193492224908_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127745683719352404640000013488072580357724576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 25.6,
    style: {
      clipPath: "url(#SVGID_00000078022253691655354530000011228213193492224908_)",
      fill: "#55BBB1"
    },
    width: 22.1,
    height: 16.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000007416217744712999660000011302375496948275862_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158735881390691646000000012614204479186053509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007416217744712999660000011302375496948275862_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158735881390691646000000012614204479186053509_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000030444514117369065910000015272879426367507112_",
    d: "M53.7,156.2h40.6c0.4,0,0.8-0.3,0.8-0.8v-13.9 c-0.5-0.1-1-0.3-1.6-0.4v13.5H53.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101803803164288758350000004276845122087004563_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030444514117369065910000015272879426367507112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101803803164288758350000004276845122087004563_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000048491301172406243480000002792976935509805446_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049190395848506215150000008622647259003949459_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048491301172406243480000002792976935509805446_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 140.1,
    style: {
      clipPath: "url(#SVGID_00000049190395848506215150000008622647259003949459_)",
      fill: "#55BBB1"
    },
    width: 43.5,
    height: 17.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147939386553210968530000010280263265293069489_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029737073666380428840000003906421515764249507_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147939386553210968530000010280263265293069489_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029737073666380428840000003906421515764249507_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000122710862086122836070000000293953929010321302_",
    d: "M53.1,154.8l0.1,0.4h40.9v-13.4 c0.2,0,0.3,0.1,0.5,0.1v13.5c0,0.1-0.1,0.3-0.3,0.3H53.2v0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084514225587880966410000007820238426719242156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122710862086122836070000000293953929010321302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000084514225587880966410000007820238426719242156_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096770671624266065550000016380841389563188380_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073710652635758575340000000706799925543120526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096770671624266065550000016380841389563188380_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.1,
    y: 140.8,
    style: {
      clipPath: "url(#SVGID_00000073710652635758575340000000706799925543120526_)",
      fill: "#55BBB1"
    },
    width: 43.5,
    height: 16.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083786569779579919280000008132031250940360577_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062164262635334782970000009661248550128433034_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083786569779579919280000008132031250940360577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062164262635334782970000009661248550128433034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157307791788086404070000018341471337111762847_",
    d: "M120.1,155.4c0,0.4,0.3,0.8,0.8,0.8h24.7 c0.2,3.3,3,5.9,6.4,5.9c3.5,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.4c-3.1,0-5.7,2.3-6.3,5.3h-24v-13.4c-0.5,0.1-1,0.3-1.6,0.4 V155.4z M151.9,151c2.6,0,4.8,2.2,4.8,4.8s-2.2,4.8-4.8,4.8s-4.8-2.2-4.8-4.8C147.1,153.1,149.3,151,151.9,151z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015313890160804747290000003094838466391176119_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157307791788086404070000018341471337111762847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015313890160804747290000003094838466391176119_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029046975692764726160000015340798362269750684_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149381828715444207400000012706802527478084262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029046975692764726160000015340798362269750684_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.1,
    y: 140.2,
    style: {
      clipPath: "url(#SVGID_00000149381828715444207400000012706802527478084262_)",
      fill: "#55BBB1"
    },
    width: 40.2,
    height: 22.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000051374100601587728620000009053462602492379534_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012465845976779923660000016303038877673023637_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051374100601587728620000009053462602492379534_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000012465845976779923660000016303038877673023637_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085232385992235660220000002522316517453896364_",
    d: "M151.9,161.6c-3,0-5.6-2.4-5.8-5.4v-0.5h-25.2 c-0.1,0-0.3-0.1-0.3-0.3V142c0.2,0,0.3-0.1,0.5-0.1v13.2h25l0.1-0.4c0.5-2.8,2.9-4.8,5.7-4.8c3.2,0,5.8,2.6,5.8,5.8 C157.8,159,155.1,161.6,151.9,161.6 M151.9,150.4c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3 S154.9,150.4,151.9,150.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005239750362095276630000015651186778151878835_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085232385992235660220000002522316517453896364_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005239750362095276630000015651186778151878835_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018954674378516050700000014945945666045899396_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037651470618395175130000002990376345341419415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018954674378516050700000014945945666045899396_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 140.9,
    style: {
      clipPath: "url(#SVGID_00000037651470618395175130000002990376345341419415_)",
      fill: "#55BBB1"
    },
    width: 39.2,
    height: 21.7
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060001560268999392780000001636967676285515410_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020387707193265211820000014143726907232453802_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060001560268999392780000001636967676285515410_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000020387707193265211820000014143726907232453802_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163046807126136325810000007683649781826313619_",
    d: "M133.4,26.6h-12.6c-0.4,0-0.8,0.4-0.8,0.8v13.9 c0.5,0.1,1,0.3,1.6,0.4V28.1h11.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117672868976128006690000015026684964021956766_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163046807126136325810000007683649781826313619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000117672868976128006690000015026684964021956766_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065058704276789421630000005554712187077844135_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182517681643047439880000000350877588514530742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065058704276789421630000005554712187077844135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.1,
    y: 25.6,
    style: {
      clipPath: "url(#SVGID_00000182517681643047439880000000350877588514530742_)",
      fill: "#55BBB1"
    },
    width: 15.4,
    height: 17.2
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114065408665144405200000001619020423535320729_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013909751433228245460000004438276756408354459_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114065408665144405200000001619020423535320729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013909751433228245460000004438276756408354459_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173852064689199243090000001770602983389231007_",
    d: "M134,28l-0.1-0.4h-12.8V41c-0.2,0-0.3-0.1-0.5-0.1 V27.4c0-0.1,0.1-0.3,0.3-0.3H134v-0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021105458056055284620000012025778344061567649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173852064689199243090000001770602983389231007_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021105458056055284620000012025778344061567649_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000136370667626342209960000000102695945595463072_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132077242488247600080000011391262026814785471_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136370667626342209960000000102695945595463072_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.6,
    y: 25.6,
    style: {
      clipPath: "url(#SVGID_00000132077242488247600080000011391262026814785471_)",
      fill: "#55BBB1"
    },
    width: 15.4,
    height: 16.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054960360447405847460000005674594740450689440_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142861931576389591160000009957180825174929590_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054960360447405847460000005674594740450689440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142861931576389591160000009957180825174929590_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131361008139397768010000004486958426401611433_",
    d: "M154.6,91.5c0-25.8-21-46.7-46.8-46.7 S61,65.8,61,91.5c0,25.8,21,46.7,46.8,46.7S154.6,117.2,154.6,91.5 M63,91.5c0-24.7,20.1-44.9,44.9-44.9 c24.7,0,44.9,20.1,44.9,44.9c0,24.7-20.1,44.9-44.9,44.9C83.1,136.3,63,116.2,63,91.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112600837546562431310000005825811015572721315_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131361008139397768010000004486958426401611433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112600837546562431310000005825811015572721315_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036965199324316930520000018119994454174625454_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180343814442597768030000005379621784591278517_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036965199324316930520000018119994454174625454_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 43.7,
    style: {
      clipPath: "url(#SVGID_00000180343814442597768030000005379621784591278517_)",
      fill: "#55BBB1"
    },
    width: 95.5,
    height: 95.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026148354438280160590000009056264170253702829_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036222652108050420610000004776825307634772671_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026148354438280160590000009056264170253702829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036222652108050420610000004776825307634772671_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000014629426520555011400000003223600217973539462_",
    d: "M107.9,137.7c-25.5,0-46.2-20.7-46.2-46.2 s20.7-46.2,46.2-46.2s46.2,20.7,46.2,46.2C154.1,116.9,133.4,137.7,107.9,137.7 M107.9,46.1c-25,0-45.4,20.4-45.4,45.4 s20.4,45.4,45.4,45.4s45.4-20.4,45.4-45.4S132.9,46.1,107.9,46.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010278711981857456810000006990877368494653620_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014629426520555011400000003223600217973539462_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000010278711981857456810000006990877368494653620_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000001642946210035034800000018099974415119097491_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062883660505734827970000016034155348816936089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001642946210035034800000018099974415119097491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 44.3,
    style: {
      clipPath: "url(#SVGID_00000062883660505734827970000016034155348816936089_)",
      fill: "#55BBB1"
    },
    width: 94.5,
    height: 94.4
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088107500909972451730000004197071896951127732_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006692075144291271390000002755069818346120624_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088107500909972451730000004197071896951127732_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006692075144291271390000002755069818346120624_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145757998311845313630000004984944029101889981_",
    d: "M117.2,38.2l0.2-1.2c-6.4-1.1-13.2-1.1-19.7,0.1 l0.2,1.2C104.3,37.2,110.9,37.2,117.2,38.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093178443610644947920000003805418398398307225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145757998311845313630000004984944029101889981_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093178443610644947920000003805418398398307225_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120540129631588683420000005358224572653037237_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018203152261108420290000013400553204255943079_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120540129631588683420000005358224572653037237_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.8,
    y: 34.9,
    style: {
      clipPath: "url(#SVGID_00000018203152261108420290000013400553204255943079_)",
      fill: "#55BBB1"
    },
    width: 21.7,
    height: 4.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029022704414061163400000001304715867134776967_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016064080579295580610000012855942436355613329_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029022704414061163400000001304715867134776967_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016064080579295580610000012855942436355613329_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160912130072200946250000008001699505216731043_",
    d: "M98.4,37.5c3.1-0.5,6.3-0.8,9.5-0.8 c3,0,6,0.2,8.9,0.7v0.2c-2.9-0.5-5.9-0.7-8.9-0.7c-3.2,0-6.4,0.3-9.5,0.8V37.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126319180952876821270000002839125777580143270_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160912130072200946250000008001699505216731043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126319180952876821270000002839125777580143270_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094575936603802736720000000765963831847149964_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077316032254690384100000017062113927890750645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094575936603802736720000000765963831847149964_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.4,
    y: 35.7,
    style: {
      clipPath: "url(#SVGID_00000077316032254690384100000017062113927890750645_)",
      fill: "#55BBB1"
    },
    width: 20.4,
    height: 3
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131329600776329409730000013776771959296935867_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078743150470910989270000007586977479316031929_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131329600776329409730000013776771959296935867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078743150470910989270000007586977479316031929_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098194159800069748310000015866058980283803570_",
    d: "M89.8,40.5l-0.4-1.2c-15.7,5.6-28.4,18.3-33.8,34 l1.2,0.4C62.1,58.4,74.4,46,89.8,40.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017506286732867365200000003618887929583873958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098194159800069748310000015866058980283803570_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017506286732867365200000003618887929583873958_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000141431037742231828520000012006682738340861613_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068670231698269763220000015283906139085748919_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141431037742231828520000012006682738340861613_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 38.3,
    style: {
      clipPath: "url(#SVGID_00000068670231698269763220000015283906139085748919_)",
      fill: "#55BBB1"
    },
    width: 36.2,
    height: 36.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067222979418194649760000004863195442353170309_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128476872340619105960000015839549023369318076_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067222979418194649760000004863195442353170309_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128476872340619105960000015839549023369318076_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013170915949972753050000016804133398615189439_",
    d: "M56.3,73.1c5.4-15.2,17.6-27.5,32.8-33l0.1,0.2 c-15.1,5.5-27.3,17.8-32.7,32.9L56.3,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039094283397042191480000016893431287727730320_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013170915949972753050000016804133398615189439_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039094283397042191480000016893431287727730320_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039854541764155954880000005901368407727411076_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011736585771605741110000018207621568977530040_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039854541764155954880000005901368407727411076_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 39,
    style: {
      clipPath: "url(#SVGID_00000011736585771605741110000018207621568977530040_)",
      fill: "#55BBB1"
    },
    width: 34.9,
    height: 35.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178175430417604977830000000083539642825943211_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109749408468028960390000002674068166409917827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178175430417604977830000000083539642825943211_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109749408468028960390000002674068166409917827_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140729995987027437840000003362159250929087646_",
    d: "M53,84.5c-0.3,2.3-0.4,4.6-0.4,6.9 c0,4.4,0.5,8.7,1.5,12.9l1.2-0.3c-1-4.1-1.5-8.4-1.5-12.6c0-2.3,0.1-4.5,0.4-6.8L53,84.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163048074216041999520000004951734073860903852_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140729995987027437840000003362159250929087646_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163048074216041999520000004951734073860903852_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093859136009695750810000005766783989176193163_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132080144609365058130000001074136697822194107_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093859136009695750810000005766783989176193163_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 83.5,
    style: {
      clipPath: "url(#SVGID_00000132080144609365058130000001074136697822194107_)",
      fill: "#55BBB1"
    },
    width: 4.7,
    height: 21.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177460272852029586940000003503049209036565389_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057133161765695332880000017528906181447846028_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177460272852029586940000003503049209036565389_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057133161765695332880000017528906181447846028_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115513039043516814870000001203781983099848884_",
    d: "M54.5,103.8c-0.9-4-1.4-8.1-1.4-12.3 c0-2.1,0.1-4.3,0.4-6.3h0.2c-0.2,2.1-0.4,4.2-0.4,6.3c0,4.1,0.5,8.3,1.4,12.2L54.5,103.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107546875186487485470000004723412657643103635_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115513039043516814870000001203781983099848884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107546875186487485470000004723412657643103635_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080207467423989036800000016920528774869485444_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033362838211373362020000009367380038057432982_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080207467423989036800000016920528774869485444_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.1,
    y: 84.1,
    style: {
      clipPath: "url(#SVGID_00000033362838211373362020000009367380038057432982_)",
      fill: "#55BBB1"
    },
    width: 3.6,
    height: 20.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137098345955440007990000000533027367545218220_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167356877037455278010000016929922346681568409_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137098345955440007990000000533027367545218220_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000167356877037455278010000016929922346681568409_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016770858249232846440000012392832867131881145_",
    d: "M88.1,143.1l0.5-1.2c-13-5-23.9-15.1-29.8-27.8 l-1.1,0.5C63.7,127.7,74.8,138,88.1,143.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019644092314042405440000002933007465047172740_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016770858249232846440000012392832867131881145_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000019644092314042405440000002933007465047172740_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002350341454809798820000017051317645734998695_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102513535932260435150000001885501986177746085_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002350341454809798820000017051317645734998695_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 113.2,
    style: {
      clipPath: "url(#SVGID_00000102513535932260435150000001885501986177746085_)",
      fill: "#55BBB1"
    },
    width: 32.9,
    height: 30.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029758856979268272100000001866067477368458409_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094620302504804486010000009119045376840013992_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029758856979268272100000001866067477368458409_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094620302504804486010000009119045376840013992_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108310981399331583700000011299898902697706119_",
    d: "M87.8,142.4c-12.8-5-23.5-15-29.4-27.5l0.2-0.1 c5.9,12.4,16.6,22.3,29.3,27.4L87.8,142.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134930675698106046440000011453513545044179600_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108310981399331583700000011299898902697706119_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134930675698106046440000011453513545044179600_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002366723211389168170000013167015991004352393_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027594956869839388070000009402521434366238366_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002366723211389168170000013167015991004352393_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.4,
    y: 113.9,
    style: {
      clipPath: "url(#SVGID_00000027594956869839388070000009402521434366238366_)",
      fill: "#55BBB1"
    },
    width: 31.5,
    height: 29.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018920305780486148020000012712260681245113243_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057138069318161286510000017680530201277925802_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018920305780486148020000012712260681245113243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057138069318161286510000017680530201277925802_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000039114170297608058240000008337168965437474445_",
    d: "M126.1,39.4l-0.4,1.2c15.4,5.4,27.7,17.9,33,33.3 l1.2-0.4C154.5,57.6,141.8,44.9,126.1,39.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111899436685091757830000013031421705139179952_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039114170297608058240000008337168965437474445_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111899436685091757830000013031421705139179952_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047758825342122873130000000096932816294836383_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123417775613216755190000012022508691182171532_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047758825342122873130000000096932816294836383_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.7,
    y: 38.4,
    style: {
      clipPath: "url(#SVGID_00000123417775613216755190000012022508691182171532_)",
      fill: "#55BBB1"
    },
    width: 36.2,
    height: 36.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000006671270563489920630000011368437992219943848_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018924431077029588360000001005754267832471951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006671270563489920630000011368437992219943848_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018924431077029588360000001005754267832471951_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031895745330408329110000018128743732818502320_",
    d: "M159,73.1c-5.4-15.1-17.6-27.4-32.7-32.9l0.1-0.2 c15.2,5.5,27.4,17.8,32.8,33L159,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127006988540958322690000001541209446849055632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031895745330408329110000018128743732818502320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127006988540958322690000001541209446849055632_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145769004846645328060000006969930824903955346_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132778429647971258230000014706530296241909121_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145769004846645328060000006969930824903955346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.4,
    y: 39,
    style: {
      clipPath: "url(#SVGID_00000132778429647971258230000014706530296241909121_)",
      fill: "#55BBB1"
    },
    width: 34.9,
    height: 35.1
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052083354402545010610000000201485929700995727_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140001347848133499460000008254070362682250173_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052083354402545010610000000201485929700995727_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140001347848133499460000008254070362682250173_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101089518941535756940000012631272066265889922_",
    d: "M161.4,104.4c1-4.2,1.5-8.6,1.5-12.9 c0-2.3-0.1-4.7-0.4-6.9l-1.2,0.2c0.3,2.2,0.4,4.5,0.4,6.8c0,4.3-0.5,8.5-1.5,12.6L161.4,104.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003789660402861671590000012564301787687780542_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101089518941535756940000012631272066265889922_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003789660402861671590000012564301787687780542_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067953795087110132080000011745368742965247369_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062167792728562123910000002127862438528693674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067953795087110132080000011745368742965247369_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.2,
    y: 83.5,
    style: {
      clipPath: "url(#SVGID_00000062167792728562123910000002127862438528693674_)",
      fill: "#55BBB1"
    },
    width: 4.7,
    height: 21.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085222121006440902920000003259271361486980749_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178198807348551335580000003664573254078744195_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085222121006440902920000003259271361486980749_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178198807348551335580000003664573254078744195_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103976432782529312840000002308005453611572659_",
    d: "M160.8,103.7c0.9-4,1.4-8.1,1.4-12.2 c0-2.1-0.1-4.2-0.4-6.3h0.2c0.2,2.1,0.4,4.2,0.4,6.3c0,4.1-0.5,8.3-1.4,12.3L160.8,103.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134241147269828350080000007146263527429415069_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103976432782529312840000002308005453611572659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134241147269828350080000007146263527429415069_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070838780580604536770000007241124441705804970_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148648270199001186560000010137226675798675343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070838780580604536770000007241124441705804970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 84.1,
    style: {
      clipPath: "url(#SVGID_00000148648270199001186560000010137226675798675343_)",
      fill: "#55BBB1"
    },
    width: 3.6,
    height: 20.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000130637236610916104520000015108158120460199333_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088828383869268745820000014778975008851084189_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130637236610916104520000015108158120460199333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088828383869268745820000014778975008851084189_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000068679379535682492080000001956483189448898954_",
    d: "M126.9,142l0.5,1.2c13.3-5.1,24.4-15.4,30.4-28.4 l-1.1-0.5C150.8,126.9,139.9,137,126.9,142"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073719168749181578770000007723630208959678619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068679379535682492080000001956483189448898954_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000073719168749181578770000007723630208959678619_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034779983092616066760000011979998991246327717_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142881114795041980380000010088523929586773127_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034779983092616066760000011979998991246327717_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.9,
    y: 113.2,
    style: {
      clipPath: "url(#SVGID_00000142881114795041980380000010088523929586773127_)",
      fill: "#55BBB1"
    },
    width: 32.9,
    height: 30.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054988663729900582390000008549571737684666017_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164474441873170011840000011127850964652410774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054988663729900582390000008549571737684666017_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000164474441873170011840000011127850964652410774_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071534517026333144160000011406671523512897209_",
    d: "M127.6,142.3c12.8-5,23.4-15,29.3-27.4l0.2,0.1 c-5.9,12.4-16.6,22.4-29.4,27.4L127.6,142.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139974260936420563800000011126721739983831449_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071534517026333144160000011406671523512897209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139974260936420563800000011126721739983831449_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000063593945955046370100000004472627195677070769_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068652978884830583020000015548894201469707942_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063593945955046370100000004472627195677070769_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 126.6,
    y: 113.9,
    style: {
      clipPath: "url(#SVGID_00000068652978884830583020000015548894201469707942_)",
      fill: "#55BBB1"
    },
    width: 31.5,
    height: 29.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165235583566923307050000012356015280720729271_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039815345741575384210000018314480530921776015_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165235583566923307050000012356015280720729271_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039815345741575384210000018314480530921776015_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009566577278744229830000010605908529481817753_",
    d: "M116.1,146.1l-0.2-1.2c-5.5,0.8-11.2,0.8-16.7-0.1 L99,146c2.9,0.5,5.9,0.7,8.8,0.7C110.6,146.8,113.4,146.5,116.1,146.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068668091037909197840000012980451917699917458_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009566577278744229830000010605908529481817753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000068668091037909197840000012980451917699917458_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000037655920127933717580000015308640357984860859_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010999726914738209350000007282790846564282774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037655920127933717580000015308640357984860859_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 143.8,
    style: {
      clipPath: "url(#SVGID_00000010999726914738209350000007282790846564282774_)",
      fill: "#55BBB1"
    },
    width: 19.1,
    height: 3.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021077296323306104100000003860841743223380881_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159449635764497721880000007649931108134154374_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021077296323306104100000003860841743223380881_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000159449635764497721880000007649931108134154374_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003092678693759617930000004024084205758349972_",
    d: "M107.9,146.2c-2.8,0-5.5-0.2-8.2-0.6v-0.2 c2.7,0.4,5.4,0.6,8.2,0.6c2.6,0,5.1-0.2,7.6-0.5v0.2C113,146,110.4,146.2,107.9,146.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062889225133351049110000012792583763875444373_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003092678693759617930000004024084205758349972_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062889225133351049110000012792583763875444373_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000115476804794931837630000012235371782107884929_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102508291675590641230000001141195041334716849_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115476804794931837630000012235371782107884929_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98.6,
    y: 144.4,
    style: {
      clipPath: "url(#SVGID_00000102508291675590641230000001141195041334716849_)",
      fill: "#55BBB1"
    },
    width: 17.9,
    height: 2.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000095315724926700491100000008350253296829879192_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041285091868058569100000015463209488344372653_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095315724926700491100000008350253296829879192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041285091868058569100000015463209488344372653_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000145044813561101347300000002466360071575085450_",
    cx: 37.9,
    cy: 156,
    r: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097467145330140917790000016581690806372917918_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145044813561101347300000002466360071575085450_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097467145330140917790000016581690806372917918_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047038993829961038310000000618139010101105560_",
    x: -114.14,
    y: -5.16,
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -98.7817 56.5836)",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161596581549300949830000017045815076308690052_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047038993829961038310000000618139010101105560_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000161596581549300949830000017045815076308690052_)",
      fill: "none",
      stroke: "#55BBB1",
      strokeWidth: 3.2732,
      strokeMiterlimit: 10.0002
    },
    cx: 37.9,
    cy: 156,
    rx: 17,
    ry: 17
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000028313618855941575060000010942620278158173091_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141432665707358361910000017015230633541108156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028313618855941575060000010942620278158173091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000141432665707358361910000017015230633541108156_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000066508132651222044190000017619099313304368797_",
    d: "M133.4,26.9c0,9.4,7.6,17,17,17s17-7.6,17-17 s-7.6-16.9-17-16.9C141,10,133.4,17.6,133.4,26.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013171039314999389390000018250788694901594797_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066508132651222044190000017619099313304368797_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013171039314999389390000018250788694901594797_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008857913397816174040000001858726971577589656_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177449071140338665290000009333033906862517392_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008857913397816174040000001858726971577589656_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000177449071140338665290000009333033906862517392_)",
      fill: "none",
      stroke: "#55BBB1",
      strokeWidth: 3.2732,
      strokeMiterlimit: 10
    },
    cx: 150.3,
    cy: 26.9,
    rx: 17,
    ry: 17
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026165492984131110660000003062954960580710836_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168104379969034282970000009001234610118758333_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026165492984131110660000003062954960580710836_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168104379969034282970000009001234610118758333_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000144317402703704770290000001799853003406420365_",
    cx: 27,
    cy: 111.1,
    r: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111174548047896969140000015646924689801033894_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144317402703704770290000001799853003406420365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111174548047896969140000015646924689801033894_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039103309473015678950000015727485551687522966_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140733172796575229050000010373163839839523764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039103309473015678950000015727485551687522966_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000140733172796575229050000010373163839839523764_)",
      fill: "none",
      stroke: "#55BBB1",
      strokeWidth: 3.2732,
      strokeMiterlimit: 10
    },
    cx: 27,
    cy: 111.1,
    rx: 17,
    ry: 17
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000009554468179588700420000012645951252323729575_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170266797591799417590000003097119216184882064_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009554468179588700420000012645951252323729575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170266797591799417590000003097119216184882064_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044168996935963306460000012804931977566914980_",
    d: "M17.1,73.5c0,9.4,7.6,17,17,17s17-7.6,17-17 s-7.6-17-17-17C24.7,56.6,17.1,64.2,17.1,73.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052811131563246090200000000844446136834735780_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044168996935963306460000012804931977566914980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052811131563246090200000000844446136834735780_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004540102035768109950000012723723990950340229_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169548205364885127090000003179755621360749193_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004540102035768109950000012723723990950340229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000169548205364885127090000003179755621360749193_)",
      fill: "none",
      stroke: "#55BBB1",
      strokeWidth: 3.2732,
      strokeMiterlimit: 10
    },
    cx: 34,
    cy: 73.5,
    rx: 17,
    ry: 17
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057122626072172769070000011498951725941026740_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033357622751937645390000004536580089727825821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057122626072172769070000011498951725941026740_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000033357622751937645390000004536580089727825821_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072985943279293839680000012403165215194164393_",
    d: "M81.7,100.5c0.5,1.5,1.1,3,1.8,4.3 c0.1,0.2,0.1,0.3-0.1,0.5l-3.6,3.6c-0.6,0.6-1,1.5-1,2.4s0.4,1.8,1,2.4l6.7,6.7c0.6,0.6,1.5,1,2.4,1s1.8-0.4,2.4-1l3.6-3.6 c0.1-0.1,0.3-0.1,0.4-0.1c1.4,0.7,2.9,1.3,4.3,1.8c0.2,0.1,0.3,0.2,0.3,0.4v5.1c0,1.9,1.5,3.4,3.4,3.4h9.5 c1.9,0,3.4-1.5,3.4-3.4v-5.1c0-0.2,0.1-0.3,0.3-0.4c1.5-0.5,3-1.1,4.4-1.8c0.2-0.1,0.3-0.1,0.4,0.1l3.6,3.6 c1.3,1.3,3.5,1.3,4.8,0l6.7-6.7c0.6-0.6,1-1.5,1-2.4s-0.4-1.8-1-2.4l-3.6-3.6c-0.1-0.1-0.1-0.3-0.1-0.5 c0.7-1.4,1.3-2.9,1.8-4.3c0.1-0.2,0.2-0.3,0.4-0.3h5.1c1.9,0,3.4-1.5,3.4-3.4v-9.4c0-1.9-1.5-3.4-3.4-3.4h-5.1 c-0.2,0-0.3-0.1-0.4-0.3c-0.5-1.5-1.1-3-1.8-4.3c-0.1-0.2-0.1-0.3,0.1-0.5l3.6-3.6c0.6-0.6,1-1.5,1-2.4s-0.4-1.8-1-2.4 l-6.7-6.7c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-3.6,3.6c-0.1,0.1-0.3,0.1-0.4,0.1c-1.4-0.7-2.9-1.3-4.4-1.8 c-0.2-0.1-0.3-0.2-0.3-0.4v-5.1c0-1.9-1.5-3.4-3.4-3.4h-9.5c-1.9,0-3.4,1.5-3.4,3.4v5.1c0,0.2-0.1,0.3-0.3,0.4 c-1.5,0.5-3,1.1-4.3,1.8c-0.2,0.1-0.3,0.1-0.4-0.1l-3.6-3.6c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-6.7,6.7 c-0.6,0.6-1,1.5-1,2.4s0.4,1.8,1,2.4l3.6,3.6c0.1,0.1,0.1,0.3,0.1,0.5c-0.7,1.4-1.3,2.8-1.8,4.3c0,0.2-0.2,0.3-0.3,0.3h-5.2 c-1.9,0-3.4,1.5-3.4,3.4v9.5c0,1.9,1.5,3.4,3.4,3.4h5.1C81.5,100.3,81.6,100.4,81.7,100.5 M74.7,96.9v-9.5 c0-0.8,0.7-1.5,1.5-1.5h5.1c1,0,1.8-0.6,2.1-1.6c0.4-1.4,1-2.8,1.7-4c0.5-0.9,0.3-1.9-0.4-2.6l-3.6-3.6 c-0.3-0.3-0.4-0.7-0.4-1.1s0.2-0.8,0.4-1.1l6.7-6.7c0.6-0.6,1.6-0.6,2.2,0l3.6,3.6c0.7,0.7,1.8,0.9,2.6,0.4 c1.3-0.7,2.7-1.2,4.1-1.7c0.9-0.3,1.6-1.2,1.6-2.1v-5.1c0-0.8,0.7-1.5,1.5-1.5h9.5c0.8,0,1.5,0.7,1.5,1.5v5.1 c0,1,0.6,1.8,1.6,2.1c1.4,0.4,2.8,1,4.1,1.7c0.9,0.5,1.9,0.3,2.6-0.4l3.6-3.6c0.6-0.6,1.6-0.6,2.2,0l6.7,6.7 c0.3,0.3,0.4,0.7,0.4,1.1s-0.2,0.8-0.4,1.1l-3.6,3.6c-0.7,0.7-0.9,1.8-0.4,2.6c0.7,1.3,1.2,2.7,1.7,4c0.3,1,1.2,1.6,2.1,1.6 h5.1c0.8,0,1.5,0.7,1.5,1.5v9.5c0,0.8-0.7,1.5-1.5,1.5H135c-1,0-1.8,0.6-2.1,1.6c-0.4,1.4-1,2.7-1.7,4 c-0.5,0.9-0.3,1.9,0.4,2.6l3.6,3.6c0.3,0.3,0.4,0.7,0.4,1.1s-0.2,0.8-0.4,1.1l-6.7,6.7c-0.6,0.6-1.6,0.6-2.2,0l-3.6-3.6 c-0.7-0.7-1.8-0.9-2.6-0.4c-1.3,0.7-2.7,1.2-4.1,1.7c-0.9,0.3-1.6,1.2-1.6,2.1v5.1c0,0.8-0.7,1.5-1.5,1.5h-9.5 c-0.8,0-1.5-0.7-1.5-1.5v-5.1c0-1-0.6-1.8-1.6-2.1c-1.4-0.4-2.8-1-4.1-1.7c-0.3-0.2-0.7-0.3-1.1-0.3c-0.6,0-1.1,0.2-1.6,0.7 l-3.6,3.6c-0.6,0.6-1.6,0.6-2.2,0l-6.7-6.7c-0.3-0.3-0.4-0.7-0.4-1.1s0.2-0.8,0.4-1.1l3.6-3.6c0.7-0.7,0.9-1.8,0.4-2.6 c-0.7-1.3-1.2-2.7-1.7-4c-0.3-1-1.2-1.6-2.1-1.6h-5C75.4,98.4,74.7,97.7,74.7,96.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003071517000940853600000000654719482228321463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072985943279293839680000012403165215194164393_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003071517000940853600000000654719482228321463_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057134525301006616790000009297483437211810980_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014616240027357223340000015803945036685289643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057134525301006616790000009297483437211810980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 55.8,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000014616240027357223340000015803945036685289643_)",
      fill: "#55BBB1"
    },
    width: 72.6,
    height: 72.6
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs130 || (_defs130 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181792654096011572550000015121349602458459320_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069358103523800223920000017029152790109774229_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181792654096011572550000015121349602458459320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000069358103523800223920000017029152790109774229_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs131 || (_defs131 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163064034307250058330000006261641907216272792_",
    d: "M103.4,127c-1.7,0-3-1.4-3-3v-5.1 c0-0.3-0.2-0.6-0.5-0.7c-1.5-0.5-2.9-1.1-4.3-1.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0-0.4,0.1-0.5,0.2l-3.6,3.6 c-0.6,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.6-0.3-2.1-0.9l-6.7-6.7c-0.6-0.6-0.9-1.3-0.9-2.1c0-0.8,0.3-1.6,0.9-2.1l3.6-3.6 c0.2-0.2,0.3-0.6,0.1-0.9c-0.7-1.4-1.3-2.8-1.8-4.3c-0.1-0.3-0.4-0.5-0.7-0.5h-5.2c-1.7,0-3-1.4-3-3v-9.5c0-1.7,1.4-3,3-3 h5.1c0.3,0,0.6-0.2,0.7-0.5c0.5-1.5,1.1-2.9,1.8-4.3c0.2-0.3,0.1-0.7-0.1-0.9l-3.6-3.6c-0.6-0.6-0.9-1.3-0.9-2.1 c0-0.8,0.3-1.6,0.9-2.1l6.7-6.7c0.6-0.6,1.3-0.9,2.1-0.9c0.8,0,1.6,0.3,2.1,0.9l3.6,3.6c0.1,0.1,0.3,0.2,0.5,0.2 c0.1,0,0.3,0,0.4-0.1c1.4-0.7,2.8-1.3,4.3-1.8c0.3-0.1,0.5-0.4,0.5-0.7v-5.1c0-1.7,1.4-3,3-3h9.5c1.7,0,3,1.4,3,3v5.1 c0,0.3,0.2,0.6,0.5,0.7c1.5,0.5,2.9,1.1,4.3,1.8c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.2l3.6-3.6 c0.6-0.6,1.3-0.9,2.1-0.9s1.6,0.3,2.1,0.9l6.7,6.7c0.6,0.6,0.9,1.3,0.9,2.1c0,0.8-0.3,1.6-0.9,2.1l-3.6,3.6 c-0.2,0.2-0.3,0.6-0.1,0.9c0.7,1.4,1.3,2.8,1.8,4.3c0.1,0.3,0.4,0.5,0.7,0.5h5.1c1.7,0,3,1.4,3,3v9.5c0,1.7-1.4,3-3,3h-5.1 c-0.3,0-0.6,0.2-0.7,0.5c-0.5,1.5-1.1,2.9-1.8,4.3c-0.2,0.3-0.1,0.7,0.1,0.9l3.6,3.6c0.6,0.6,0.9,1.3,0.9,2.1 c0,0.8-0.3,1.6-0.9,2.1l-6.7,6.7c-0.6,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.6-0.3-2.1-0.9l-3.6-3.6c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.1,0-0.3,0-0.4,0.1c-1.4,0.7-2.8,1.3-4.3,1.8c-0.3,0.1-0.5,0.4-0.5,0.7v5.1c0,1.7-1.4,3-3,3H103.4z M95.2,115.2 c0.3,0,0.6,0.1,0.9,0.2c1.3,0.7,2.7,1.3,4.1,1.7c0.8,0.2,1.3,1,1.3,1.8v5.1c0,1,0.8,1.9,1.9,1.9h9.5c1,0,1.9-0.8,1.9-1.9 v-5.1c0-0.8,0.5-1.5,1.3-1.8c1.4-0.5,2.8-1,4.1-1.7c0.3-0.1,0.6-0.2,0.9-0.2c0.5,0,1,0.2,1.3,0.5l3.6,3.6 c0.4,0.4,0.8,0.6,1.3,0.6s1-0.2,1.3-0.6l6.7-6.7c0.4-0.4,0.6-0.8,0.6-1.3s-0.2-1-0.6-1.3l-3.6-3.6c-0.6-0.6-0.7-1.5-0.3-2.2 c0.7-1.3,1.3-2.7,1.7-4.1c0.3-0.8,1-1.3,1.8-1.3h5.1c1,0,1.9-0.8,1.9-1.9v-9.5c0-1-0.8-1.9-1.9-1.9h-5.1 c-0.8,0-1.5-0.5-1.8-1.3c-0.4-1.4-1-2.8-1.7-4.1c-0.4-0.7-0.3-1.6,0.3-2.2l3.6-3.6c0.4-0.4,0.6-0.8,0.6-1.3s-0.2-1-0.6-1.3 l-6.7-6.7c-0.3-0.3-0.8-0.5-1.3-0.5s-1,0.2-1.3,0.5l-3.6,3.6c-0.3,0.3-0.8,0.5-1.3,0.5c-0.3,0-0.6-0.1-0.9-0.2 c-1.3-0.7-2.7-1.3-4.1-1.7c-0.8-0.2-1.3-1-1.3-1.8v-5.1c0-1-0.8-1.9-1.9-1.9h-9.5c-1,0-1.9,0.8-1.9,1.9v5.1 c0,0.8-0.5,1.5-1.3,1.8c-1.4,0.5-2.8,1-4.1,1.7c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1-0.2-1.3-0.5L90.3,65 c-0.3-0.3-0.8-0.5-1.3-0.5s-1,0.2-1.3,0.5L81,71.7c-0.4,0.4-0.6,0.8-0.6,1.3s0.2,1,0.6,1.3l3.6,3.6c0.6,0.6,0.7,1.5,0.3,2.2 c-0.7,1.3-1.3,2.7-1.7,4.1c-0.2,0.8-1,1.3-1.8,1.3h-5.2c-1,0-1.9,0.8-1.9,1.9v9.5c0,1,0.8,1.9,1.9,1.9h5.1 c0.8,0,1.5,0.5,1.8,1.3c0.5,1.4,1,2.8,1.7,4.1c0.4,0.7,0.2,1.6-0.3,2.2l-3.6,3.6c-0.4,0.4-0.6,0.8-0.6,1.3s0.2,1,0.6,1.3 l6.7,6.7c0.3,0.3,0.8,0.5,1.3,0.5s1-0.2,1.3-0.5l3.6-3.6C94.2,115.4,94.7,115.2,95.2,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085219030334834329860000001403865533531924138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163064034307250058330000006261641907216272792_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085219030334834329860000001403865533531924138_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs132 || (_defs132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121984113965304603970000001107036829729769114_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157996409701398828280000003953809180575655863_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121984113965304603970000001107036829729769114_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 56.2,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000157996409701398828280000003953809180575655863_)",
      fill: "#55BBB1"
    },
    width: 71.9,
    height: 71.8
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs133 || (_defs133 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000001624258704588630700000008841271565179941506_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160173110783852550600000017983158721983421093_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001624258704588630700000008841271565179941506_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160173110783852550600000017983158721983421093_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs134 || (_defs134 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000104674044157241886510000015722535683601034401_",
    d: "M108.1,106.5c7.9,0,14.4-6.4,14.4-14.4 s-6.4-14.4-14.4-14.4c-7.9,0-14.4,6.4-14.4,14.4S100.2,106.5,108.1,106.5 M108.1,79.7c6.9,0,12.5,5.6,12.5,12.5 s-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5C95.7,85.3,101.3,79.7,108.1,79.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163054331766125204920000011664887156661650344_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104674044157241886510000015722535683601034401_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163054331766125204920000011664887156661650344_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs135 || (_defs135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000174561584664135953090000012230104982142421439_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074415665544916083210000002805958755310610350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174561584664135953090000012230104982142421439_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 76.8,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000074415665544916083210000002805958755310610350_)",
      fill: "#55BBB1"
    },
    width: 30.7,
    height: 30.7
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs136 || (_defs136 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075876608965341620550000017210469113485906339_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081647472017053809050000009967015889613148814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075876608965341620550000017210469113485906339_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000081647472017053809050000009967015889613148814_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs137 || (_defs137 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089534363256615729700000017042731908154968992_",
    d: "M108.1,106.1c-7.7,0-14-6.3-14-14s6.3-14,14-14 s14,6.3,14,14S115.8,106.1,108.1,106.1 M108.1,79.3c-7.1,0-12.8,5.8-12.8,12.8s5.8,12.8,12.8,12.8c7.1,0,12.8-5.8,12.8-12.8 S115.2,79.3,108.1,79.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169528812635371817260000006495127325330236812_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089534363256615729700000017042731908154968992_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000169528812635371817260000006495127325330236812_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs138 || (_defs138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069373857687055340960000012106157746660056710_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069383930723153539860000007948305213778632870_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069373857687055340960000012106157746660056710_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 77.2,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000069383930723153539860000007948305213778632870_)",
      fill: "#55BBB1"
    },
    width: 30,
    height: 30
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs139 || (_defs139 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003818781194143020270000012260927101286929795_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053516366320874635340000003199456578610466198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003818781194143020270000012260927101286929795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053516366320874635340000003199456578610466198_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs140 || (_defs140 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132785159337376081470000003979892665317534855_",
    d: "M108.1,110.6c10.2,0,18.5-8.3,18.5-18.5 s-8.3-18.5-18.5-18.5s-18.5,8.3-18.5,18.5C89.7,102.3,98,110.6,108.1,110.6 M108.1,74.3c9.8,0,17.8,8,17.8,17.8 s-8,17.8-17.8,17.8s-17.8-8-17.8-17.8S98.3,74.3,108.1,74.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131357841350123981270000008246001956910613437_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132785159337376081470000003979892665317534855_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131357841350123981270000008246001956910613437_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs141 || (_defs141 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176037967995668853990000010427068366719034022_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170969097184431741330000011096514969313251728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176037967995668853990000010427068366719034022_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 72.7,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000170969097184431741330000011096514969313251728_)",
      fill: "#55BBB1"
    },
    width: 38.9,
    height: 38.9
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs142 || (_defs142 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145025253611305463500000007255053451891397035_",
    x: 10,
    y: 10,
    width: 177,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119109128975569425390000005425652863056737968_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145025253611305463500000007255053451891397035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119109128975569425390000005425652863056737968_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs143 || (_defs143 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013191421545402289390000010771019026993331391_",
    d: "M108.1,110.6c10.2,0,18.5-8.3,18.5-18.5 s-8.3-18.5-18.5-18.5s-18.5,8.3-18.5,18.5C89.7,102.3,98,110.6,108.1,110.6 M108.1,74.3c9.8,0,17.8,8,17.8,17.8 s-8,17.8-17.8,17.8s-17.8-8-17.8-17.8S98.3,74.3,108.1,74.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047050771433007236690000010787528170696064921_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013191421545402289390000010771019026993331391_",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047050771433007236690000010787528170696064921_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs144 || (_defs144 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147926937736488891900000002830549757778840197_",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135655286268605636700000006922293286061311882_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147926937736488891900000002830549757778840197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 72.7,
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000135655286268605636700000006922293286061311882_)",
      fill: "#55BBB1"
    },
    width: 38.9,
    height: 38.9
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsGear);
export default __webpack_public_path__ + "static/media/Controls-gear.9413203b75a86072520d9392c9bb0329.svg";
export { ForwardRef as ReactComponent };